import e, { Children as t, createContext as n, useCallback as r, useContext as i, useEffect as a, useLayoutEffect as o, useMemo as s, useReducer as c, useRef as l, useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { Editor as m, Editor as h, Element as g, Element as _, Node as v, Node as y, Path as b, Point as x, Range as S, Range as C, Text as ee, Text as w, Transforms as T, Transforms as E, createEditor as D } from "slate";
import { Editable as te, ReactEditor as O, Slate as k, useFocused as ne, useSelected as A, useSlate as j, useSlateSelection as M, useSlateSelector as re, useSlateStatic as N, withReact as P } from "slate-react";
import * as F from "yjs";
import { CursorEditor as I, YjsEditor as L, relativePositionToSlatePoint as ie, slatePointToRelativePosition as ae, withCursors as R, withYHistory as oe, withYjs as se } from "@slate-yjs/core";
import { withHistory as ce } from "slate-history";
import { useRemoteCursorOverlayPositions as le } from "@slate-yjs/react";
import { createPortal as z } from "react-dom";
//#region \0rolldown/runtime.js
var ue = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports);
//#endregion
//#region lib/utils/injectStyles.ts
if (typeof document < "u") {
	let e = "textbit-keyframes";
	if (!document.getElementById(e)) {
		let t = document.createElement("style");
		t.id = e, t.textContent = [
			"@keyframes block-caret-blink{0%,100%{opacity:1}50%{opacity:0}}",
			"[data-state=\"active\"] .tb-focus-ring{outline:1px solid currentColor;outline-offset:4px;border-radius:var(--tb-focus-ring-radius,5px);opacity:0.3}",
			".tb-newline{background:var(--tb-newline-background,color-mix(in srgb,currentColor 18%,transparent));box-shadow:inset 0 0 0 1px var(--tb-newline-border,color-mix(in srgb,currentColor 45%,transparent));border-radius:var(--tb-newline-radius,2px)}",
			".tb-newline::before{content:var(--tb-newline-symbol,'\\21B5');opacity:0.6;user-select:none;-webkit-user-select:none;pointer-events:none}"
		].join(""), document.head.appendChild(t);
	}
}
var de = n({
	verbose: !1,
	readOnly: !1,
	collaborative: !1,
	dir: "ltr",
	lang: "en",
	debounce: 250,
	spellcheckDebounce: 1250,
	placeholder: "",
	placeholders: "none",
	stats: {
		full: {
			words: 0,
			characters: 0
		},
		short: {
			words: 0,
			characters: 0
		}
	},
	dispatch: () => {}
}), fe = (e, t) => {
	let { stats: n } = t, r = {};
	return n && (r.stats = n), {
		...e,
		...r
	};
};
function pe({ children: e, verbose: t, readOnly: n, collaborative: r, dir: i, lang: a, debounce: o, spellcheckDebounce: s, placeholder: l, placeholders: u }) {
	let [d, p] = c(fe, {
		verbose: t ?? !1,
		readOnly: n ?? !1,
		collaborative: r ?? !1,
		dir: i ?? "ltr",
		lang: a ?? "en",
		debounce: o ?? 250,
		spellcheckDebounce: s ?? 1250,
		placeholder: l ?? "",
		placeholders: u ?? "none",
		stats: {
			full: {
				words: 0,
				characters: 0
			},
			short: {
				words: 0,
				characters: 0
			}
		},
		dispatch: () => {}
	});
	return /* @__PURE__ */ f(de.Provider, {
		value: {
			...d,
			dispatch: p
		},
		children: e
	});
}
//#endregion
//#region lib/contexts/PluginRegistry/lib/registerPlugin.ts
function me(e, t, n) {
	n?.verbose && console.info(`Registering plugin ${t.name}`);
	let r = [...e], i = r.findIndex((e) => e.name === t.name);
	return i === -1 ? r.push(t) : (console.warn(`%c Overriding already registered plugin ${t.name}`), r[i] = t), r;
}
//#endregion
//#region lib/contexts/PluginRegistry/lib/registerComponents.ts
var he = (e, t, n, r, i) => {
	let a = /* @__PURE__ */ new Map();
	return e.forEach((e, t) => {
		a.set(t, e);
	}), ge(a, t, n, r || {}, i || {}), a;
}, ge = (e, t, n, r, i) => {
	e.has(t) && r.verbose && console.info(`%c Component ${t} render function overrided by new render component with the same type`), n.class || console.warn(`Component ${t} is missing a class, using "text" as fallback type`), e.set(t, {
		type: t,
		class: n.class || "text",
		componentEntry: n,
		parent: r?.parent || null,
		pluginOptions: i || /* @__PURE__ */ new Map()
	});
	let { children: a = [] } = n;
	a.forEach((a) => {
		if (!a.type) throw Error(`Child component of ${t} is missing mandatory type`);
		ge(e, `${t}/${a.type}`, a, {
			verbose: r.verbose,
			parent: n
		}, i);
	});
}, _e = (/* @__PURE__ */ ue(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return s(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return c(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		var a = t && t.byKey, o = {};
		e = e.replace("++", "+add");
		var s = e.split("+"), c = s.length;
		for (var d in n) o[n[d]] = !1;
		var f = !0, p = !1, m = void 0;
		try {
			for (var h = s[Symbol.iterator](), g; !(f = (g = h.next()).done); f = !0) {
				var _ = g.value, v = _.endsWith("?") && _.length > 1;
				v && (_ = _.slice(0, -1));
				var y = u(_), b = n[y];
				if (_.length > 1 && !b && !r[_] && !i[y]) throw TypeError("Unknown modifier: \"" + _ + "\"");
				(c === 1 || !b) && (a ? o.key = y : o.which = l(_)), b && (o[b] = !v || null);
			}
		} catch (e) {
			p = !0, m = e;
		} finally {
			try {
				!f && h.return && h.return();
			} finally {
				if (p) throw m;
			}
		}
		return o;
	}
	function c(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], (i != null || r !== !1) && i !== r)) return !1;
		}
		return !0;
	}
	function l(e) {
		return e = u(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function u(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o;
})))(), ve = (e) => {
	let t = [];
	return e.filter((e) => Array.isArray(e.actions) && e.actions.length).forEach((e) => {
		e.actions?.forEach((n) => {
			let r = typeof n.hotkey == "string" ? (0, _e.isHotkey)(n.hotkey) : () => !1;
			t.push({
				plugin: e,
				isHotkey: r,
				...n,
				name: `${e.name}/${n.name}`
			});
		});
	}), t;
}, B = {
	isLeafPlugin: (e) => e?.class === "leaf",
	isElementPlugin: (e) => e?.class !== "leaf"
}, V = () => ({
	plugins: [],
	components: /* @__PURE__ */ new Map(),
	actions: [],
	verbose: !1,
	dispatch: () => {}
}), ye = n(V()), be = (e, t) => {
	let { action: n, plugin: r } = t;
	return n === "delete" ? (console.warn("Deleting plugins from plugin registry not implemented"), e) : {
		...e,
		...Se(e, r, { verbose: e.verbose })
	};
};
function xe({ children: e, verbose: t, plugins: n }) {
	let r = Ce(V(), n, { verbose: t }), [i, a] = c(be, {
		...V(),
		...r
	});
	return /* @__PURE__ */ f(ye.Provider, {
		value: {
			...i,
			dispatch: a
		},
		children: e
	});
}
function Se(e, t, n) {
	let r = me(e.plugins, t, n);
	return {
		plugins: r,
		actions: ve(r),
		components: B.isElementPlugin(t) && t?.componentEntry ? he(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options) : e.components
	};
}
function Ce(e, t, n) {
	return t.forEach((t) => {
		e.plugins = me(e.plugins, t, n), e.actions = ve(e.plugins), B.isElementPlugin(t) && t?.componentEntry && (e.components = he(e.components, t.componentEntry?.type || t.name, t.componentEntry, n, t.options));
	}), { ...e };
}
//#endregion
//#region lib/utils/textbit-element.ts
var H = {
	isTextLeaf: (e) => w.isText(e),
	..._,
	isBlock: (e) => _.isAncestor(e) && _.isElement(e) && e.class === "block",
	isText: (e) => _.isElement(e) && e.class === "text",
	isVoid: (e) => _.isElement(e) && e.class === "void",
	isInline: (e) => _.isElement(e) && e.class === "inline",
	isOfType: (e, t) => _.isElement(e) && e?.type === t,
	hasId: (e, t) => _.isElement(e) && e?.id === t
}, U = {
	...h,
	position: (e) => {
		let { selection: t } = e;
		if (!t) return -1;
		let n = h.unhangRange(e, t);
		return n && n.anchor.path.length ? n.anchor.path[0] : -1;
	},
	length: (e) => Array.from(h.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => _.isElement(e)
	})).length,
	parents: (e) => h.nodes(e, {
		at: [],
		mode: "highest",
		match: (e) => _.isElement(e)
	}),
	selectedTextEntries: (e) => {
		if (!C.isRange(e.selection)) return [];
		let t = h.nodes(e, {
			at: e.selection,
			match: (e) => w.isText(e)
		});
		return Array.from(t);
	},
	includes: (e, t) => {
		let { selection: n } = e;
		if (!n) return !1;
		let [r] = Array.from(h.nodes(e, {
			at: h.unhangRange(e, n),
			match: (e) => !h.isEditor(e) && _.isElement(e) && e.type === t
		}));
		return !!r;
	},
	getSelectedText: (e, t) => {
		let n = t || h.unhangRange(e, e.selection);
		return h.string(e, n);
	},
	replaceStringAtPosition: (e, t, n) => {
		if (!e.selection) return;
		let r = e.selection.anchor, [i] = h.node(e, r.path);
		if (!w.isText(i)) return;
		let a = r.offset - t.length;
		a < 0 && (a = 0);
		let o = -1, s = -1;
		for (; (a = i.text.indexOf(t, a)) !== -1;) {
			if (r.offset >= a && r.offset <= a + t.length) {
				o = a, s = a + t.length;
				break;
			}
			a += 1;
		}
		if (o === -1) return;
		let c = {
			anchor: {
				path: r.path,
				offset: o
			},
			focus: {
				path: r.path,
				offset: s
			}
		};
		E.insertText(e, n, { at: c });
	},
	insertAt(e, t, n) {
		(Array.isArray(n) ? n : [n]).length && E.insertNodes(e, n, { at: [t] });
	},
	hasText(e) {
		for (let [t] of e) for (let e of y.texts(t)) if (e[0].text.trim() !== "") return !0;
		return !1;
	},
	convertToTextNode(e, t, n = void 0) {
		if (!e.selection) return;
		let r = Array.from(h.nodes(e, {
			mode: "highest",
			at: h.unhangRange(e, e.selection),
			match: (e) => !h.isEditor(e)
		}));
		r.length && h.withoutNormalizing(e, () => {
			for (let i = 0; i < r.length; i++) {
				let [a, o] = r[i];
				if (!H.isOfType(a, "core/text") && H.isText(a)) {
					let r = a.id;
					E.removeNodes(e, { at: o });
					let i = y.string(a);
					E.insertNodes(e, {
						id: r,
						class: "text",
						type: t,
						properties: n ? { role: n } : {},
						children: [{ text: i }]
					}, { at: o }), e.select({
						anchor: {
							path: o.concat(0),
							offset: 0
						},
						focus: {
							path: o.concat(0),
							offset: 0
						}
					});
				} else H.isOfType(a, "core/text") && E.setNodes(e, {
					type: "core/text",
					properties: n ? { role: n } : {}
				}, { at: o });
			}
		});
	}
}, we = () => ({
	class: "text",
	name: "core/text",
	componentEntry: {
		class: "text",
		component: Te,
		placeholder: "¶"
	},
	actions: [{
		name: "set-text",
		title: "Text",
		handler: ({ editor: e }) => {
			U.convertToTextNode(e, "core/text");
		},
		visibility: (e) => [
			e.type === "core/text",
			!0,
			e.type === "core/text" && !e?.properties?.role
		]
	}]
});
function Te(e) {
	return /* @__PURE__ */ f(d, { children: e.children });
}
//#endregion
//#region lib/components/core/Leafs/index.tsx
var Ee = () => ({
	class: "leaf",
	name: "core/bold",
	actions: [{
		name: "toggle-bold",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontWeight: "bold" },
			children: "B"
		}),
		hotkey: "mod+b",
		handler: () => !0
	}],
	getStyle: () => ({ fontWeight: "bold" })
}), De = () => ({
	class: "leaf",
	name: "core/italic",
	actions: [{
		name: "toggle-italic",
		tool: () => /* @__PURE__ */ f("div", {
			style: { fontStyle: "italic" },
			children: "I"
		}),
		hotkey: "mod+i",
		handler: () => !0
	}],
	getStyle: () => ({ fontStyle: "italic" })
}), Oe = () => ({
	class: "leaf",
	name: "core/underline",
	actions: [{
		name: "toggle-underline",
		hotkey: "mod+u",
		tool: () => /* @__PURE__ */ f("div", {
			style: { textDecoration: "underline" },
			children: "U"
		}),
		handler: () => !0
	}],
	getStyle: () => ({ textDecoration: "underline" })
}), ke = () => ({
	class: "generic",
	name: "navigation",
	actions: [{
		name: "move-text-up",
		hotkey: "mod+option+up",
		handler: ({ editor: e }) => {
			let t = U.position(e);
			t < 1 || E.moveNodes(e, {
				at: [t],
				to: [t - 1]
			});
		}
	}, {
		name: "move-text-down",
		hotkey: "mod+option+down",
		handler: ({ editor: e }) => {
			let t = U.position(e), n = U.length(e);
			t < 0 || t + 1 === n || E.moveNodes(e, {
				at: [t],
				to: [t + 1]
			});
		}
	}]
}), Ae = [
	we,
	Ee,
	De,
	Oe
], je = [ke], Me = {
	menu: void 0,
	spelling: void 0,
	dispatch: () => {}
}, W = n(Me), Ne = (e, t) => {
	let { menu: n, spelling: r } = t, i = {};
	return i.menu = n, i.spelling = r, {
		...e,
		...i
	};
};
function Pe({ children: e }) {
	let [t, n] = c(Ne, { ...Me }), r = {
		...t,
		dispatch: n
	};
	return /* @__PURE__ */ f(W.Provider, {
		value: r,
		children: e
	});
}
//#endregion
//#region lib/contexts/SelectionBoundsContext.tsx
var Fe = n(void 0);
//#endregion
//#region lib/contexts/SelectionBoundsProvider.tsx
function Ie({ children: e }) {
	let t = l(void 0), n = l(/* @__PURE__ */ new Set()), i = N(), o = r((e) => (n.current.add(e), e(t.current), () => {
		n.current.delete(e);
	}), []), s = r(() => {
		n.current.forEach((e) => {
			e(t.current);
		});
	}, []), c = r(() => {
		let e = window.getSelection();
		if (!e || e.rangeCount === 0) {
			t.current = void 0, s();
			return;
		}
		let n = e.getRangeAt(0), { top: r, right: a, bottom: o, left: c, width: l, height: u, x: d, y: f } = n.getBoundingClientRect(), p;
		if (i && O.isFocused(i) && i.selection) try {
			let [e] = h.nodes(i, {
				at: i.selection,
				match: (e) => _.isElement(e) && h.isBlock(i, e)
			});
			if (e) {
				let [t] = e;
				p = O.toDOMNode(i, t).getBoundingClientRect();
			}
		} catch (e) {
			console.warn("Failed to get Slate element bounds:", e);
		}
		let m = {
			top: r,
			right: a,
			bottom: o,
			left: c,
			width: l,
			height: u,
			x: d,
			y: f,
			isCollapsed: n.collapsed,
			box: p
		};
		JSON.stringify(t.current) !== JSON.stringify(m) && (t.current = m, s());
	}, [s, i]);
	a(() => {
		c();
		let e = () => {
			requestAnimationFrame(() => {
				c();
			});
		}, t = () => {
			c();
		};
		return document.addEventListener("selectionchange", e, {
			capture: !0,
			passive: !0
		}), window.addEventListener("scroll", t, {
			capture: !0,
			passive: !0
		}), () => {
			document.removeEventListener("selectionchange", e, { capture: !0 }), window.removeEventListener("scroll", t, { capture: !0 });
		};
	}, [c]);
	let u = {
		boundsRef: t,
		subscribe: o
	};
	return /* @__PURE__ */ f(Fe.Provider, {
		value: u,
		children: e
	});
}
//#endregion
//#region lib/utils/calculateStats.ts
function Le(e) {
	let t = Array.from(h.nodes(e, {
		at: [],
		match: (e, t) => _.isElement(e) && ["core/text"].includes(e.type || "") && e.properties?.role !== "vignette" && t.length === 1
	}));
	return {
		full: Re(Array.from(h.nodes(e, {
			at: [],
			match: (e) => _.isElement(e) && ["text"].includes(e.class || "")
		}))),
		short: Re(t)
	};
}
function Re(e) {
	let t = 0, n = 0;
	for (let [r] of e) {
		let e = y.string(r).trim();
		t += (e.match(/\p{L}+/gu) || []).length, n += e.length;
	}
	return {
		words: t,
		characters: n
	};
}
//#endregion
//#region lib/utils/debounce.ts
var ze = (e, t) => {
	let n, r = (...r) => {
		clearTimeout(n), n = setTimeout(() => {
			e(...r);
		}, t);
	};
	return r.force = (...t) => {
		clearTimeout(n), e(...t);
	}, r.cancel = () => {
		clearTimeout(n);
	}, r;
};
//#endregion
//#region lib/with/withLang.ts
function Be(e, t) {
	return e.lang = t || document?.documentElement?.lang || navigator.language || "en", e;
}
//#endregion
//#region lib/with/withSpeling.ts
function Ve(e, t, n = 6125) {
	let { onChange: r } = e, i = null;
	return e.spellingLookupTable = /* @__PURE__ */ new Map(), e.onSpellcheckComplete = (e) => {
		i = e;
	}, e.spellcheck = ze(async () => {
		if (!t) return;
		let [n, r, a] = await He(e, t, e.spellingLookupTable);
		n && r.length > 0 && (e.spellingLookupTable = a, i?.(a, r));
	}, n), e.onChange = (t) => {
		r(t), e.operations.filter((e) => [
			"insert_text",
			"remove_text",
			"split_node",
			"merge_node"
		].includes(e.type)).length && e.spellcheck && e.spellcheck();
	}, e;
}
async function He(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i = [], a = [];
	for (let t of e.children) {
		if (!_.isElement(t) || !t.id) continue;
		let a = n.get(t.id), o = y.string(t);
		if (!a || a.text !== o) {
			let n = o.trim() === "";
			r.set(t.id, {
				lang: t.lang || e.lang,
				text: o,
				errors: [],
				check: !n
			}), n || i.push(t.id);
		} else r.set(t.id, {
			...a,
			check: !1
		});
	}
	if (!i.length) return [
		!1,
		[],
		r
	];
	let o = await t(Array.from(r.values()).filter((e) => e.check).map((e) => ({
		text: e.text,
		lang: e.lang
	})));
	if (o.length !== i.length) return console.warn("Number of spellchecked texts differ from requested number of texts to spellcheck"), [
		!1,
		[],
		r
	];
	for (let e = 0; e < i.length; e++) {
		let t = i[e], n = r.get(t);
		n && (n.errors = o[e].filter((e) => e?.text && Array.isArray(e?.suggestions)).map((e) => ({
			id: crypto.randomUUID(),
			text: e.text,
			level: e.level,
			suggestions: e.suggestions || []
		})), a.push(t));
	}
	return [
		!0,
		a,
		r
	];
}
//#endregion
//#region lib/with/withTextbitElements.ts
function Ue(e) {
	let { isInline: t, isBlock: n, isVoid: r } = e;
	return e.isInline = (e) => _.isElement(e) && e.class === "inline" ? !0 : t(e), e.isBlock = (e) => _.isAncestor(e) && _.isElement(e) && e.class === "block" ? !0 : n(e), e.isVoid = (e) => _.isElement(e) && e.class === "void" ? !0 : r(e), e.isTextBlock = (e) => _.isElement(e) && e.class === "text", e.isOfType = (e, t) => _.isElement(e) && e?.type === t, e;
}
//#endregion
//#region lib/utils/pasteToConsumer.ts
function We(e, t, n) {
	let [r, i] = Ge(t, n);
	return typeof r == "function" && new Promise((t) => {
		r({
			input: n,
			editor: e
		}).then((n) => {
			typeof n?.data == "object" && i === n.type ? (Ke(e, n.data), t()) : typeof n?.data == "string" && i === "text/plain" ? t(n?.data) : (console.warn("Unexpected output from consumer when handling paste", n), t());
		});
	});
}
function Ge(e, t) {
	for (let n of e) {
		let [e, r] = n?.consumes({ input: t }) || [!1];
		if (e) return [n.consume, r];
	}
	return [void 0, void 0];
}
function Ke(e, t) {
	if (!C.isRange(e.selection)) return;
	let n = h.unhangRange(e, e.selection), r = n && n.anchor.path[0] > 0 ? n.anchor.path[0] : 0, i = y.get(e, [r]);
	_.isElement(i) && (i?.class === "text" && h.string(e, [r]) === "" ? E.removeNodes(e, { at: [r] }) : r++, E.insertNodes(e, t, {
		at: [r],
		select: !0
	}));
}
//#endregion
//#region lib/with/withInsertText.ts
function qe(e, t) {
	let { insertText: n } = e, r = t.filter((e) => B.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	return e.insertText = (t) => {
		let i = We(e, r, {
			source: "text",
			type: "text/plain",
			data: t
		});
		if (!(i instanceof Promise)) {
			n(t);
			return;
		}
		i.then((e) => {
			n(typeof e == "string" ? e : t);
		});
	}, e;
}
//#endregion
//#region lib/with/withNormalizeNode.ts
function Je(e, t, n) {
	let { normalizeNode: r } = e;
	return e.normalizeNode = (t) => {
		let [i, a] = t;
		if (!_.isElement(i)) return r(t);
		let o = n.get(i.type);
		if (!o) {
			if (a.length === 1 && !i.type && n.has("core/text") && $e(i)) {
				E.setNodes(e, {
					type: "core/text",
					class: "text",
					properties: {}
				}, { at: a });
				return;
			}
			return r(t);
		}
		Ye(e, t, o) || (typeof o.componentEntry.constraints?.normalizeNode != "function" || !0 !== o.componentEntry.constraints.normalizeNode(e, t)) && r(t);
	}, e;
}
function Ye(e, t, n) {
	let [r, i] = t;
	if (!_.isElement(r)) return !1;
	let a = n.componentEntry.children;
	if (!a || a.length === 0) return !1;
	let o = a.filter((e) => e.constraints?.min !== void 0 || e.constraints?.max !== void 0);
	if (o.length === 0) return !1;
	let s = n.type;
	for (let t of o) {
		let n = t.constraints?.max;
		if (n === void 0) continue;
		let a = Xe(r, `${s}/${t.type}`);
		if (a.length > n) {
			let t = a[a.length - 1];
			return E.removeNodes(e, { at: [...i, t] }), !0;
		}
	}
	for (let t of o) {
		let n = t.constraints?.min;
		if (n === void 0) continue;
		let o = `${s}/${t.type}`;
		if (Xe(r, o).length < n) {
			let n = Ze(r, a, t);
			return E.insertNodes(e, et(t, o), { at: [...i, n] }), !0;
		}
	}
	let c = /* @__PURE__ */ new Map();
	a.forEach((e, t) => {
		e.type && c.set(`${s}/${e.type}`, t);
	});
	let l = r.children.map((e) => _.isElement(e) ? c.get(e.type) ?? Infinity : Infinity);
	for (let t = 1; t < l.length; t++) if (l[t] < l[t - 1]) {
		let n = 0;
		for (let e = 0; e < t; e++) {
			if (l[e] >= l[t]) {
				n = e;
				break;
			}
			n = e + 1;
		}
		return E.moveNodes(e, {
			at: [...i, t],
			to: [...i, n]
		}), !0;
	}
	return !1;
}
function Xe(e, t) {
	let n = [];
	for (let r = 0; r < e.children.length; r++) {
		let i = e.children[r];
		_.isElement(i) && i.type === t && n.push(r);
	}
	return n;
}
function Ze(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	t.forEach((e, t) => r.set(e.type, t));
	let i = r.get(n.type) ?? 0, a = 0;
	for (let n = 0; n < e.children.length; n++) {
		let r = e.children[n];
		_.isElement(r) && Qe(r.type, t) < i && (a = n + 1);
	}
	return a;
}
function Qe(e, t) {
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		if (r.type && e.endsWith(`/${r.type}`)) return n;
	}
	return Infinity;
}
function $e(e) {
	return e.children.every((e) => !_.isElement(e) || H.isInline(e));
}
function et(e, t) {
	let n = {
		id: crypto.randomUUID(),
		type: t,
		children: [{ text: "" }]
	};
	switch (e.class) {
		case "void": return {
			...n,
			class: "void"
		};
		case "block": return {
			...n,
			class: "block"
		};
		case "text": return {
			...n,
			class: "text",
			properties: {}
		};
		default: return {
			...n,
			class: "text",
			properties: {}
		};
	}
}
//#endregion
//#region lib/with/withEditableVoids.ts
function tt(e, t) {
	let { isVoid: n } = e, r = [], i = [];
	return t.forEach((e) => {
		r.push(e.type), e.class === "void" && i.push(e.type);
	}), e.isVoid = (e) => i.includes(e.type) || !r.includes(e.type) ? !0 : n(e), e;
}
//#endregion
//#region lib/with/withInsertBreak.ts
function nt(e, t) {
	let { insertBreak: n } = e;
	return e.insertBreak = () => {
		if (!rt(e, t)) return;
		let { selection: r } = e;
		if (r && C.isCollapsed(r)) {
			let [, t] = h.node(e, r);
			for (let [n, r] of h.levels(e, { at: t })) if (!(r.length <= 1) && H.isBlock(n)) {
				E.splitNodes(e, {
					match: (e) => _.isElement(e),
					mode: "lowest",
					always: !0
				});
				return;
			}
		}
		let { isAtEnd: i, next: a } = at(e) || {};
		if (i) {
			if (!it(e, t)) {
				n();
				return;
			}
			E.insertNodes(e, {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			}, a ? { at: a } : void 0), a && E.select(e, h.start(e, a));
			return;
		}
		n();
	}, e;
}
function rt(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = C.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r, i] of h.levels(e, { at: n })) {
		if (!_.isElement(r)) continue;
		let n = t.get(r.type);
		if (!n) continue;
		if (n.componentEntry?.constraints?.allowBreak === !1) return !1;
		let a = n.componentEntry?.constraints?.max;
		if (a !== void 0 && i.length > 1) {
			let t = i.slice(0, -1), [n] = h.node(e, t);
			if (_.isElement(n)) {
				let e = 0;
				for (let t of n.children) _.isElement(t) && t.type === r.type && e++;
				if (e >= a) return !1;
			}
		}
	}
	return !0;
}
function it(e, t) {
	let { selection: n } = e;
	if (!n) return !0;
	let r = C.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus];
	for (let n of r) for (let [r] of h.levels(e, { at: n })) if (_.isElement(r) && t.get(r.type)?.componentEntry?.constraints?.allowExitBreak === !1) return !1;
	return !0;
}
function at(e) {
	let { selection: t } = e;
	if (!t || !C.isCollapsed(t)) return;
	let [n, r] = h.node(e, t);
	if (!w.isText(n)) return;
	let i = [r[0]], a = h.node(e, i), o = h.last(e, i);
	return {
		isAtEnd: h.isEnd(e, t.anchor, o?.[1] ?? r),
		next: H.isBlock(a[0]) ? b.next(a[1]) : void 0
	};
}
//#endregion
//#region lib/with/withInsertSoftBreak.ts
function ot(e, t) {
	return e.insertSoftBreak = () => {
		st(e, t) && E.insertText(e, "\n");
	}, e;
}
function st(e, t) {
	let { selection: n } = e;
	if (!n) return !1;
	let r = C.isCollapsed(n) ? [n.anchor] : [n.anchor, n.focus], i = !1;
	for (let n of r) for (let [r] of h.levels(e, { at: n })) {
		if (!_.isElement(r)) continue;
		let e = t.get(r.type)?.componentEntry?.constraints;
		if (e?.allowSoftBreak === !1) return !1;
		e?.allowSoftBreak === !0 && (i = !0);
	}
	return i;
}
//#endregion
//#region lib/utils/componentConstraints.ts
function ct(e) {
	let { allowBreak: t, allowSoftBreak: n, normalizeNode: r, allowEdgeWhitespace: i, min: a, max: o } = e?.constraints ?? {};
	return {
		min: a,
		max: o,
		allowBreak: t ?? !0,
		allowSoftBreak: n ?? !1,
		allowEdgeWhitespace: i ?? !0,
		normalizeNode: r instanceof Function ? r : void 0
	};
}
//#endregion
//#region lib/utils/normalizeWhitespace.ts
var lt = "\xA0";
function ut(e) {
	return e && e.replace(/\s+/g, (e) => e.includes(lt) ? lt : " ");
}
//#endregion
//#region lib/utils/normalizeLineEndings.ts
function dt(e) {
	return e.replace(/\r\n|\r/g, "\n");
}
//#endregion
//#region lib/utils/pasteToParagraphs.ts
function ft(e, t, n) {
	let { selection: r } = e;
	if (!r) return !1;
	let i = C.edges(r);
	if (!C.isCollapsed(r) && b.compare(i[0].path, i[1].path) !== 0) return !1;
	let a = U.parent(e, r), o = a[0], { componentEntry: s = void 0 } = t.get(o.type) || {};
	if (!s || o.class !== "text") return !1;
	let c, { allowBreak: l } = ct(s);
	c = l ? dt(n).replace(/\n{2,}/g, "\n").trim().split("\n").map((e) => e.trim()) : [ut(n)];
	let u = "core/text", d;
	a[1].length > 1 && (u = o.type, d = o.properties);
	let f = c.map((e) => ({
		id: crypto.randomUUID(),
		type: u,
		class: "text",
		children: [{ text: e }],
		properties: d
	})), p = f.shift();
	return p && E.insertFragment(e, [p]), E.insertNodes(e, f), !0;
}
//#endregion
//#region lib/utils/utils.ts
function pt(e) {
	let { selection: t } = e;
	return Array.from(h.nodes(e, {
		at: h.unhangRange(e, t),
		match: (e) => !h.isEditor(e) && _.isElement(e) && [
			"block",
			"void",
			"text",
			"textblock"
		].includes(e.class || "")
	}));
}
function mt(e) {
	return pt(e).map((e) => e[0]);
}
function ht(e, t) {
	try {
		if (O.hasDOMNode(e, t)) {
			let n = O.toSlateNode(e, t);
			return [n, O.findPath(e, n)];
		}
	} catch (e) {
		console.warn(e);
	}
}
function gt(e, t) {
	let n, r;
	if (document.caretPositionFromPoint) {
		let e = document.caretPositionFromPoint(t.clientX, t.clientY);
		n = e?.offsetNode, r = e?.offset ?? 0;
	} else if (document.caretRangeFromPoint) {
		let e = document.caretRangeFromPoint(t.clientX, t.clientY);
		n = e?.startContainer, r = e?.startOffset ?? 0;
	} else return;
	if (!n || n?.nodeType !== 3) return;
	let i = O.findEventRange(e, t), a = i.anchor.offset <= i.focus.offset, o = n.nodeValue?.length || 0;
	return {
		anchor: {
			path: i.anchor.path,
			offset: i.anchor.offset + (a ? -r : o - r)
		},
		focus: {
			path: i.focus.path,
			offset: i.focus.offset + (a ? o - r : -r)
		}
	};
}
//#endregion
//#region lib/with/withInsertHtml.ts
function _t(e, t, n) {
	let { insertData: r, insertText: i } = e, a = n.filter((e) => B.isElementPlugin(e) && !!e.consumer?.consume && !!e.consumer?.consumes).map(({ consumer: e }) => e);
	e.insertData = (n) => {
		let { types: o } = n, { selection: s } = e, c = !0;
		if (s && C.isCollapsed(s)) {
			let n = mt(e), r = n.length && n[n.length - 1];
			_.isElement(r) && (c = t.get(r.type || "")?.componentEntry.constraints?.allowBreak ?? !0);
		}
		if (c && o.includes("application/x-slate-fragment")) return r(n);
		let l = We(e, a, {
			source: "html",
			type: "text/html",
			data: n
		});
		if (l instanceof Promise) {
			l.then((e) => {
				if (typeof e == "string") return i(e);
			});
			return;
		}
		if (o.includes("text/plain")) {
			let r = n.getData("text/plain"), i = /\n{2,}/.test(dt(r));
			if (r && (!c || o.includes("text/html") || i) && ft(e, t, r)) return;
		}
		r(n);
	};
}
//#endregion
//#region lib/with/withUniqueIds.ts
function vt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		if (n.type === "insert_node") {
			let r = yt(e, n.node);
			if (r) return t({
				...n,
				node: r
			});
		}
		if (n.type === "split_node") {
			let r = n.properties;
			if ("id" in r && typeof r.id == "string" && xt(e, r)) return t({
				...n,
				properties: {
					...n.properties,
					id: crypto.randomUUID()
				}
			});
		}
		t(n);
	}, e;
}
function yt(e, t) {
	if (!_.isElement(t)) return null;
	let n = bt(e), r = !1, i = structuredClone(t), a = (e) => {
		if (_.isElement(e)) {
			(!e.id || n.has(e.id)) && (e.id = crypto.randomUUID(), r = !0), n.add(e.id);
			for (let t of e.children) a(t);
		}
	};
	return a(i), r ? i : null;
}
function bt(e) {
	let t = /* @__PURE__ */ new Set();
	for (let [n] of h.nodes(e, {
		at: [],
		mode: "all"
	})) !h.isEditor(n) && _.isElement(n) && typeof n.id == "string" && t.add(n.id);
	return t;
}
function xt(e, t) {
	return t.id ? Array.from(h.nodes(e, {
		at: [],
		mode: "all",
		match: (e) => !h.isEditor(e) && _.isElement(e) && e.id === t.id
	})).length > 0 : !1;
}
//#endregion
//#region lib/with/withDeletionManagement.ts
function St(e) {
	let { deleteBackward: t, deleteForward: n } = e;
	return e.deleteBackward = (n) => {
		let { selection: r } = e;
		if (r && Ct(e)) {
			let [i] = h.nodes(e, {
				match: (t) => _.isElement(t) && h.isBlock(e, t),
				at: r
			});
			if (!i) return t(n);
			let [a, o] = i, s = y.string(a), c = h.first(e, o);
			if (c && H.isBlock(a) && b.equals(r.focus.path, c[1]) && r.focus.offset === 0) return;
			if (!s.length && o[0] === 0) {
				e.children.length > 1 && E.removeNodes(e, { at: o });
				return;
			}
			let l = b.next(o);
			if (!s.length && l[0] >= e.children.length) {
				E.removeNodes(e, { at: o });
				return;
			}
			if (o[0] > 0) {
				let t = b.previous(o), n = h.node(e, t);
				if (n) {
					let [r] = n;
					if (_.isElement(r) && r.class === "block") {
						s.length ? E.removeNodes(e, { at: t }) : (E.removeNodes(e, { at: o }), E.select(e, h.end(e, t)));
						return;
					}
				}
			}
		}
		t(n);
	}, e.deleteForward = (t) => {
		let { selection: r } = e;
		if (r && wt(e)) {
			let [i] = h.nodes(e, {
				match: (t) => _.isElement(t) && h.isBlock(e, t),
				at: r
			});
			if (!i) return n(t);
			let [a, o] = i, s = y.string(a);
			if (!s.length && o[0] === 0 && e.children.length > 1) {
				E.removeNodes(e, { at: o });
				return;
			}
			if (o[0] < e.children.length - 1) {
				let [t, n] = h.node(e, [o[0] + 1]);
				if (_.isElement(t) && t.class === "block") {
					s.length ? E.removeNodes(e, { at: n }) : (E.removeNodes(e, { at: o }), E.select(e, h.end(e, [o[0] - 1])));
					return;
				}
			}
		}
		n(t);
	}, e;
}
function Ct(e) {
	let { selection: t } = e;
	if (!t || !C.isCollapsed(t)) return !1;
	let [n, r] = h.node(e, t);
	if (!w.isText(n)) return !1;
	let i = [r[0]], a = h.first(e, i);
	return h.isStart(e, t.anchor, a?.[1] ?? r);
}
function wt(e) {
	let { selection: t } = e;
	if (!t || !C.isCollapsed(t)) return !1;
	let [n, r] = h.node(e, t);
	if (!w.isText(n)) return !1;
	let i = [r[0]], a = h.last(e, i);
	return h.isEnd(e, t.anchor, a?.[1] ?? r);
}
//#endregion
//#region lib/with/withInsertFragment.ts
function Tt(e, t) {
	let { insertFragment: n } = e;
	return e.insertFragment = (r, i) => {
		let { selection: a } = e;
		if (!a) {
			n(r, i);
			return;
		}
		if (r.length === 1 && Et(r[0])) {
			let e = Ot(r[0]);
			e.length && n(e, i);
			return;
		}
		if (!r.every(H.isText) && jt(e, a, t)) {
			let t = r.map((e) => y.string(e)).join("\n");
			e.insertText(t);
			return;
		}
		if (!r.every(H.isText)) {
			let t = a.anchor, o = a.focus;
			if (t.path[0] === o.path[0]) {
				let n = t.path[0], i = e.children[n];
				if (_.isElement(i) && i.class === "text") {
					C.isCollapsed(a) || E.delete(e);
					let t = e.selection.anchor, i = x.equals(t, h.start(e, [n])), o = x.equals(t, h.end(e, [n])), s = !i && !o, c = i ? n : n + 1;
					h.withoutNormalizing(e, () => {
						s && E.splitNodes(e, {
							at: t,
							match: (e, t) => t.length === 1
						});
						for (let t = 0; t < r.length; t++) E.insertNodes(e, r[t], { at: [c + t] });
					}), E.select(e, h.end(e, [c + r.length - 1]));
					return;
				}
			}
			n(r, i);
			return;
		}
		let [o, s] = C.edges(a), c = b.equals(o.path, s.path) ? s : kt(e, s), [l] = At(e, o.path, c.path) ?? [];
		if (!H.isText(l)) {
			n(r, i);
			return;
		}
		if (y.string(l)?.length && C.isCollapsed(a)) {
			n(r, i);
			return;
		}
		let u = r.map((e) => {
			if (e.type === l.type && e.properties?.role === l.properties?.role) return e;
			let t = { ...e };
			return t.properties ? t.properties.role = l.properties?.role : t.properties = { role: l.properties?.role }, t;
		});
		n(u, i);
	}, e;
}
function Et(e) {
	return !_.isElement(e) || e.class === "text" ? !1 : Dt(e);
}
function Dt(e) {
	return w.isText(e) ? !0 : !_.isElement(e) || e.class === "void" ? !1 : e.class === "text" ? e.children.every((e) => w.isText(e)) : e.children.length === 1 && Dt(e.children[0]);
}
function Ot(e) {
	return w.isText(e) ? [e] : _.isElement(e) ? e.children.flatMap(Ot) : [];
}
function kt(e, t) {
	if (t.offset !== 0 || t.path[0] === 0) return t;
	try {
		let n = h.start(e, [t.path[0]]);
		if (x.equals(t, n)) return h.end(e, [t.path[0] - 1]);
	} catch (e) {
		console.trace(e);
	}
	return t;
}
function At(e, t, n) {
	let r = b.equals(t, n) ? t : b.common(t, n);
	for (; r.length > 0;) try {
		let [t] = h.node(e, r);
		if (_.isElement(t) && t.class === "text") return [t, r];
		r = r.slice(0, -1);
	} catch (e) {
		console.trace(e);
	}
	return null;
}
function jt(e, t, n) {
	let r = t.anchor.path;
	if (r.length <= 1) return !1;
	for (let t = r.length - 1; t >= 1; t--) {
		let i = r.slice(0, t);
		try {
			let [t] = h.node(e, i);
			if (!_.isElement(t)) continue;
			if (t.class !== "text") return !1;
			let r = n.get(t.type);
			return r ? r.parent !== null : !1;
		} catch {
			return !1;
		}
	}
	return !1;
}
//#endregion
//#region lib/with/withTrimWhitespace.ts
function Mt(e) {
	let { insertText: t } = e;
	return e.insertText = (n) => {
		if (e.allowEdgeWhitespace === !1 && /^[\t\n\r\f\v ]+$/.test(n)) {
			let { selection: t } = e;
			if (t && C.isCollapsed(t)) {
				for (let [n, r] of h.levels(e, { at: t.anchor })) if (!(!_.isElement(n) || r.length !== 1) && h.isStart(e, t.anchor, r)) return;
			}
		}
		t(n);
	}, e;
}
//#endregion
//#region lib/utils/blockBoundarySelection.ts
function G(e) {
	let { selection: t } = e;
	if (!t || C.isCollapsed(t)) return !1;
	let n = Nt(e, t.anchor.path), r = Nt(e, t.focus.path);
	return !(n === void 0 && r === void 0 || n && r && b.equals(n, r));
}
function Nt(e, t) {
	return h.above(e, {
		at: t,
		match: (e) => _.isElement(e) && H.isBlock(e)
	})?.[1];
}
function Pt(e, t) {
	h.withoutNormalizing(e, () => {
		let n = Array.from(h.nodes(e, {
			at: t,
			match: (e) => w.isText(e)
		})).reverse();
		for (let [, r] of n) {
			let n = C.intersection(t, h.range(e, r));
			n && !C.isCollapsed(n) && E.delete(e, { at: n });
		}
	});
}
//#endregion
//#region lib/with/withBlockBoundaryGuard.ts
function Ft(e) {
	let { insertText: t, insertFragment: n, insertData: r, insertBreak: i, insertSoftBreak: a, deleteFragment: o } = e;
	return e.insertText = (n, r) => {
		if (G(e)) {
			It(e, () => t(n, r));
			return;
		}
		t(n, r);
	}, e.insertData = (n) => {
		if (G(e)) {
			if (n.types.includes("application/x-slate-fragment")) return;
			let r = n.getData("text/plain");
			r && It(e, () => t(r));
			return;
		}
		r(n);
	}, e.insertFragment = (t, r) => {
		G(e) || n(t, r);
	}, e.insertBreak = () => {
		G(e) || i();
	}, e.insertSoftBreak = () => {
		G(e) || a();
	}, e.deleteFragment = (t) => {
		if (G(e)) {
			let { selection: t } = e;
			if (t) {
				let n = h.pointRef(e, t.focus);
				Pt(e, t);
				let r = n.unref();
				r && E.select(e, r);
			}
			return;
		}
		o(t);
	}, e;
}
function It(e, t) {
	let { selection: n } = e;
	if (!n) return;
	let r = h.pointRef(e, n.focus);
	Pt(e, n);
	let i = r.unref();
	i && (E.select(e, i), t());
}
//#endregion
//#region lib/with/withSelectionGuard.ts
function Lt(e) {
	let { apply: t } = e;
	return e.apply = (n) => {
		t(n);
		let r = e.selection;
		r && (!Rt(e, r.anchor.path) || !Rt(e, r.focus.path)) && (console.warn("[textbit] Cleared stale selection that pointed outside the document.", {
			selection: r,
			op: n
		}), E.deselect(e));
	}, e;
}
function Rt(e, t) {
	let n = e;
	for (let e = 0; e < t.length; e++) {
		let r = t[e];
		if (r < 0 || r >= n.children.length) return !1;
		let i = n.children[r];
		if (e === t.length - 1) return !0;
		if (!_.isElement(i)) return !1;
		n = i;
	}
	return !0;
}
//#endregion
//#region lib/components/SlateContainer.tsx
function zt(e) {
	let { children: t, value: n, readOnly: i } = e, { debounce: o, spellcheckDebounce: c, dispatch: u, lang: d } = q(), { plugins: p, components: m } = K(), h = l(null), g = l(Symbol("textbit-editor"));
	if (!h.current) {
		let t = P(D());
		Vt(e) ? (t = oe(se(t, e.value, { localOrigin: g.current })), L.isYjsEditor(t) && Ht(e) && (t = R(t, e.awareness, {
			autoSend: e.cursor?.autoSend ?? !0,
			data: e.cursor?.data ?? void 0,
			cursorStateField: e.cursor?.stateField,
			cursorDataField: e.cursor?.dataField
		}))) : t = ce(t), Be(t, d), e.onSpellcheck && !i && Ve(t, e.onSpellcheck, c), Ue(t), qe(t, p), Tt(t, m), Je(t, p, m), tt(t, m), Mt(t), nt(t, m), ot(t, m), _t(t, m, p), vt(t), St(t), Ft(t), Lt(t), h.current = t;
	}
	let _ = h.current;
	a(() => {
		if (L.isYjsEditor(_)) return L.connect(_), () => {
			L.disconnect(_);
		};
	}, [_]);
	let v = s(() => n instanceof F.XmlText ? [] : typeof n == "string" ? Bt(n) : n, [n]), b = r((t) => {
		e.onChange && (Wt(e) || Vt(e) ? e.onChange(t) : Ut(e) && e.onChange(t.map((e) => y.string(e)).join("\n"))), u({ stats: Le(_) });
	}, [
		e.onChange,
		e.value,
		u
	]), x = s(() => i ? () => {} : ze(b, o || 1250), [
		b,
		i,
		o
	]);
	return a(() => (_.spellcheck?.force(), u({ stats: Le(_) }), () => {
		_.spellcheck?.cancel();
	}), [_, u]), /* @__PURE__ */ f(k, {
		editor: _,
		initialValue: v,
		onChange: x,
		children: t
	});
}
function Bt(e) {
	return e.split("\n").map((e) => ({
		id: crypto.randomUUID(),
		type: "core/text",
		class: "text",
		children: [{ text: e }]
	}));
}
function Vt(e) {
	return e.value instanceof F.XmlText;
}
function Ht(e) {
	return e.value instanceof F.XmlText && "awareness" in e && e.awareness != null;
}
function Ut(e) {
	return typeof e.value == "string";
}
function Wt(e) {
	return !Vt(e) && !Ut(e);
}
//#endregion
//#region lib/components/GutterProvider/GutterContext.tsx
var Gt = n({
	triggerRef: void 0,
	updateTriggerRef: () => {}
});
//#endregion
//#region lib/components/GutterProvider/GutterProvider.tsx
function Kt({ children: e }) {
	let t = l(void 0), n = r((e) => {
		t.current = e;
	}, []);
	return /* @__PURE__ */ f(Gt.Provider, {
		value: {
			triggerRef: t,
			updateTriggerRef: n
		},
		children: e
	});
}
//#endregion
//#region lib/components/TextbitRoot.tsx
function qt(e) {
	let { children: t, verbose: n, readOnly: r, debounce: i, spellcheckDebounce: a, placeholders: o, plugins: s, className: c, style: l, placeholder: u } = e, d = {
		boxSizing: "border-box",
		textRendering: "optimizeLegibility",
		WebkitFontSmoothing: "antialiased",
		MozOsxFontSmoothing: "grayscale",
		...l
	};
	return /* @__PURE__ */ f("div", {
		className: c,
		style: d,
		children: /* @__PURE__ */ f(pe, {
			verbose: !!n,
			readOnly: r,
			collaborative: !r && Jt(e),
			debounce: i,
			spellcheckDebounce: a,
			placeholders: o,
			placeholder: u,
			dir: e.dir,
			lang: e.lang,
			children: /* @__PURE__ */ f(xe, {
				verbose: !!n,
				plugins: [...je.map((e) => e()), ...Array.isArray(s) && s.length ? s : Ae.map((e) => e())],
				children: /* @__PURE__ */ f(zt, {
					...e,
					children: /* @__PURE__ */ f(Ie, { children: /* @__PURE__ */ f(Pe, { children: /* @__PURE__ */ f(Kt, { children: t }) }) })
				})
			})
		})
	});
}
function Jt(e) {
	return e.value instanceof F.XmlText && "awareness" in e && e.awareness != null;
}
//#endregion
//#region lib/utils/getDecorationRanges.ts
var Yt = "\xA0";
function Xt(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Zt(e, t, n, r, i, a, o) {
	let [s, c] = n, l = [];
	if (t?.size && w.isText(s)) {
		let [n] = h.node(e, [c[0]]);
		if (_.isElement(n) && n.id) {
			let e = t.get(n.id);
			if (e?.errors.length) {
				let t = s.text;
				e.errors.forEach((e) => {
					let n = Xt(e.text), r = RegExp(`(?<!\\p{L})${n}(?!\\p{L})`, "giu");
					[...t.matchAll(r)].forEach((t) => {
						t.index !== void 0 && l.push({
							anchor: {
								path: c,
								offset: t.index
							},
							focus: {
								path: c,
								offset: t.index + e.text.length
							},
							spellingError: e
						});
					});
				});
			}
		}
	}
	if (w.isText(s)) for (let e = 0; e < s.text.length; e++) {
		let t = s.text[e];
		t === "\n" ? l.push({
			anchor: {
				path: c,
				offset: e
			},
			focus: {
				path: c,
				offset: e + 1
			},
			newline: !0
		}) : t === Yt && l.push({
			anchor: {
				path: c,
				offset: e
			},
			focus: {
				path: c,
				offset: e + 1
			},
			nonBreakingSpace: !0
		});
	}
	if (c.length === 2 && w.isText(s) && !s.text && i !== "none") {
		let t = y.parent(e, c);
		if (_.isElement(t) && y.string(t) === "") {
			let n = t.id === e.children[0].id;
			if (i === "multiple" || i === "single" && n && o !== !1) {
				let e = r.get(t.type)?.componentEntry?.placeholder, n = i === "single" ? a : typeof e == "function" ? e(t) : e ?? "";
				l.push({
					anchor: {
						path: c,
						offset: 0
					},
					focus: {
						path: c,
						offset: 0
					},
					placeholder: n
				});
			}
		}
	}
	return l;
}
//#endregion
//#region lib/components/Element/ChildElement.tsx
function Qt({ attributes: e, children: t, element: n, entry: r, rootNode: i, options: a }) {
	let o = N(), s = n.lang || o.lang, c = typeof n.properties?.role == "string" && n.properties.role.length > 0 ? n.properties.role : null;
	if (!r.asOwnElement) {
		let { component: l } = r;
		return /* @__PURE__ */ f("div", {
			lang: s,
			"data-id": n.id,
			"data-type": n.type,
			...c ? { "data-role": c } : {},
			...e,
			children: /* @__PURE__ */ f(l, {
				element: n,
				rootNode: i,
				options: a,
				editor: o,
				children: t
			})
		});
	}
	let { component: l } = r, u = {
		...e,
		lang: s,
		"data-id": n.id,
		"data-type": n.type,
		...c ? { "data-role": c } : {}
	};
	return /* @__PURE__ */ f(l, {
		element: n,
		attributes: u,
		rootNode: i,
		options: a,
		editor: o,
		children: t
	});
}
//#endregion
//#region lib/contexts/DragStateContext.tsx
var $t = n({
	dragOver: !1,
	onDragEnter: () => {},
	onDragLeave: () => {},
	onDrop: () => {},
	setOffset: () => {}
});
//#endregion
//#region lib/utils/pipes.ts
function en(e, t, n) {
	let r = [], i = n.target.files;
	if (!i) return;
	for (let e of i) {
		let t = {
			kind: "file",
			type: e.type,
			name: e.name,
			source: "fileinput",
			input: e,
			consumer: [],
			output: void 0
		};
		r.push(t);
	}
	rn(t, r);
	let a = nn(r), o = 0, s = pt(e);
	if (s) {
		let [, e] = s[s.length - 1];
		o = e[0] + 1;
	} else o = Array.from(h.nodes(e, {
		at: [0],
		match: (e) => !h.isEditor(e) && _.isElement(e)
	})).length;
	on(e, a, t, n, o);
}
function tn(e, t, n, r) {
	let i = n.dataTransfer, a = an(i);
	rn(t, a), on(e, nn(a), t, n, r);
}
function nn(e) {
	let t = [];
	return e.forEach((e) => {
		let n = t.find((t) => t.consumer.find((t) => !!e.consumer.find((e) => e.name === t.name)));
		n ? (e.consumer.forEach((e) => {
			n.consumer.find((t) => t.name === e.name) || n.consumer.push(e);
		}), n.pipe.push(e)) : t.push({
			consumer: e.consumer,
			pipe: [e]
		});
	}), t;
}
function rn(e, t) {
	for (let n of t) {
		let { source: t, type: r, input: i } = n;
		e.forEach((e) => {
			if (!B.isElementPlugin(e) || typeof e.consumer?.consumes != "function") return !1;
			let [a, o = void 0, s = !1] = e.consumer.consumes({ input: {
				source: t,
				type: r,
				data: i
			} });
			a === !0 && n.consumer.push({
				name: e.name,
				produces: o || void 0,
				aggregate: s
			});
		});
	}
}
function an(e) {
	let t = [], n = !0;
	e.types.includes("text/plain") && (e.types.includes("text/uri-list") || e.types.includes("text/html")) && (n = !1);
	for (let r = 0; r < e.items.length; r++) {
		let i = e.items[r];
		i.kind === "file" ? t.push(dn("drop", i)) : i.type === "text/uri-list" ? t.push(...fn("drop", e, i, !n)) : i.type === "text/html" ? t.push(un("drop", e, i, !n)) : i.type === "text/plain" ? n && t.push(ln("drop", e, i)) : t.push(ln("drop", e, i));
	}
	return t;
}
async function on(e, t, n, r, i) {
	if (t.length) {
		r.preventDefault(), r.stopPropagation();
		let a = 0;
		for (let r of t) {
			if (r.consumer.length === 0) {
				if (r.pipe.find((e) => e.type === "textbit/droppable-id")) pn(e, r.pipe[0].input, i);
				else {
					let e = r.pipe.map((e) => e.type).join(", ");
					console.warn(`Ignored dropped data/files of type ${e}`);
				}
				continue;
			}
			a += await sn(r, e, n, i, a);
		}
	}
}
async function sn(e, t, n, r, i) {
	let a = e.consumer[0], o = n.find((e) => B.isElementPlugin(e) && e.name === a.name), s = o?.consumer?.consume || void 0, c = a?.produces;
	if (!o || !s) return console.warn(`Could not find plugin <${a.name}> or it's consume() function to handle pipe item from $(pipeItem.source})`), 0;
	let l = 0;
	if (a.aggregate) cn(s, e.pipe.map((e) => ({
		source: e.source,
		type: e.type,
		data: e.input
	})), c, t, r + i), l++;
	else for (let n of e.pipe) cn(s, {
		source: n.source,
		type: n.type,
		data: n.input
	}, c, t, r + i + l), l++;
	return l;
}
async function cn(e, t, n, r, i) {
	let a = h.pathRef(r, [i]), o = r.pendingDrops?.start({
		pathRef: a,
		kind: n
	}), s = () => {
		o && r.pendingDrops?.end(o), a.unref();
	}, c;
	try {
		c = await e({
			input: t,
			editor: r
		});
	} catch (e) {
		console.warn(e.message), s();
		return;
	}
	if (c === void 0) {
		s();
		return;
	}
	if (typeof c != "object" || !c || c.type !== n || c.data === void 0) {
		console.warn(`consume(): unexpected result for "${n}"; discarding.`, c), s();
		return;
	}
	let l = a.current;
	if (!l) {
		console.warn(`Drop position for "${n}" was removed before consume() resolved; dropping the consumed result.`), s();
		return;
	}
	let u = c.data;
	E.insertNodes(r, u, {
		at: l,
		select: !1
	}), s();
}
function ln(e, t, n) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		consumer: [],
		output: void 0
	};
}
function un(e, t, n, r) {
	return {
		kind: n.kind,
		type: n.type,
		source: e,
		input: t.getData(n.type),
		alternate: r ? t.getData("text/plain") : void 0,
		consumer: [],
		output: void 0
	};
}
function dn(e, t) {
	return {
		kind: t.kind,
		type: t.type,
		source: e,
		input: t.getAsFile(),
		consumer: [],
		output: void 0
	};
}
function fn(e, t, n, r) {
	let i = t.getData(n.type), a = [], o = r ? t.getData("text/plain") : void 0;
	for (let t of i.split("\r\n")) a.push({
		kind: n.kind,
		type: n.type,
		source: e,
		input: t,
		alternate: o,
		consumer: [],
		output: void 0
	});
	return a;
}
function pn(e, t, n) {
	let r = 0, i;
	for (let n of e.children) {
		if (_.isElement(n) && n.id === t) {
			i = n;
			break;
		}
		r++;
	}
	i && E.moveNodes(e, {
		at: [r],
		to: [n]
	});
}
//#endregion
//#region lib/hooks/usePluginRegistry.tsx
function K() {
	let e = i(ye);
	if (!e) throw Error("useTextbit must be used within a PluginRegistryContextProvider");
	return e;
}
//#endregion
//#region lib/hooks/useTextbit.tsx
var q = () => {
	let e = i(de);
	if (!e) throw Error("useTextbit must be used within a TextbitProvider");
	return e;
};
//#endregion
//#region lib/utils/hasDraggableTarget.ts
function mn(e) {
	let t = e.target;
	for (; t && t !== e.currentTarget;) {
		if (t.getAttribute("draggable") === "true") return !0;
		t = t.parentElement;
	}
	return !1;
}
//#endregion
//#region lib/utils/hasDraggableElement.ts
function hn(e, t) {
	let n = O.findEventRange(e, t);
	if (!C.isRange(n)) return !1;
	let r = n.anchor.path;
	do {
		let t = y.get(e, r);
		if (_.isElement(t) && t.class === "text") return !1;
		r = r.slice(0, -1);
	} while (r.length > 0);
	return !0;
}
//#endregion
//#region lib/components/Element/Droppable.tsx
function gn({ children: e, element: t }) {
	let { readOnly: n } = q(), a = N(), o = i($t), { plugins: s } = K(), c = l(null), u = s.find((e) => e.name === t?.type), d = B.isElementPlugin(u) && !!u?.componentEntry?.droppable, p = r((e) => {
		if (!(n || !t?.id)) {
			if (!mn(e) && !hn(a, e)) {
				e.stopPropagation(), e.preventDefault();
				return;
			}
			e.stopPropagation(), c?.current && vn(c.current, e, t.id);
		}
	}, [
		n,
		t?.id,
		a
	]), m = r((e) => !n && (e.preventDefault(), e.stopPropagation(), !0), [n]), h = r((e) => {
		m(e) && o?.onDragEnter();
	}, [o, m]), g = r((e) => {
		m(e) && o?.onDragLeave();
	}, [o, m]), _ = r((e) => {
		m(e) && o.setOffset(bn(e, c?.current, d));
	}, [
		o,
		m,
		d
	]), v = r((e) => {
		if (n) {
			e.preventDefault();
			return;
		}
		if (o?.onDrop && o.onDrop(e), !c.current || !t?.id) return;
		let r = yn(a, e, c.current, t.id, d);
		r && tn(a, s, e, r[0]);
	}, [
		o,
		t?.id,
		a,
		d,
		s,
		c,
		n
	]), y = r(() => {
		n || (o?.onDragLeave(), c?.current && (c.current.style.opacity = "1", _n()));
	}, [n, o]);
	return /* @__PURE__ */ f("div", {
		"data-id": t?.id || "",
		ref: c,
		draggable: !n && ["block", "void"].includes(t?.class || "") ? "true" : "false",
		onDragStartCapture: p,
		onDragEnterCapture: h,
		onDragLeaveCapture: g,
		onDragOverCapture: _,
		onDropCapture: v,
		onDragEnd: y,
		children: e
	});
}
function _n() {
	let e = document.getElementsByClassName("textbit-dragged-temp");
	if (e.length) for (let t of e) t.parentNode && t.parentNode.removeChild(t);
}
function vn(e, t, n) {
	let r = e.cloneNode(!0), { left: i, top: a } = e.getBoundingClientRect(), o = r.firstChild;
	o.style.transform = "scale(0.6) rotate(2deg)", r.style.width = `${e.offsetWidth}px`, r.style.height = `${e.offsetHeight}px`, r.style.position = "absolute", r.style.top = "-9999px", r.classList.add("textbit-dragged-temp"), document.body.appendChild(r), e.style.opacity = "0.5", t.dataTransfer.clearData(), t.dataTransfer.setData("textbit/droppable-id", n), t.dataTransfer.setDragImage(r, t.clientX - i, t.clientY - a);
}
function yn(e, t, n, r, i) {
	let a = e.children.findIndex((e) => _.isElement(e) && e.id === r);
	return a < 0 ? null : [a + (bn(t, n, i)?.position?.[0] === "above" ? 0 : 1), e.children[a]];
}
function bn(e, t, n) {
	if (!t) return;
	let r = t.getBoundingClientRect(), i = e.clientY;
	if (e.clientX < r.left || e.clientX > r.right) return {
		position: void 0,
		bbox: r
	};
	let a = (i - r.top) / r.height * 100, o;
	return o = a <= 20 ? ["above", !1] : a <= 50 ? ["above", n] : a >= 80 ? ["below", n] : ["below", !1], {
		position: o,
		bbox: r
	};
}
//#endregion
//#region lib/contexts/AdjacentBlockContext.tsx
var xn = n(null);
//#endregion
//#region lib/hooks/useAdjacentBlock.tsx
function Sn() {
	return i(xn);
}
//#endregion
//#region lib/contexts/BlockSelectionContext.tsx
var Cn = n(null);
//#endregion
//#region lib/hooks/useBlockSelection.tsx
function wn() {
	return i(Cn);
}
//#endregion
//#region lib/components/Element/ParentElement.tsx
function Tn(e) {
	let t = A(), n = N(), r = Sn(), i = wn(), { element: a, attributes: o, entry: s } = e;
	if (s.asOwnElement) return null;
	let c = (() => {
		if (!i) return !1;
		let e = n.children.findIndex((e) => e === a);
		if (e === -1) return !1;
		let t = Math.min(i.anchorIndex, i.focusIndex), r = Math.max(i.anchorIndex, i.focusIndex);
		return e >= t && e <= r;
	})(), l = r && r.blockId === a.id ? r.direction : null, u = typeof a.properties?.role == "string" && a.properties.role.length > 0 ? a.properties.role : null, d = {
		position: "absolute",
		top: 0,
		bottom: 0,
		insetInlineEnd: -5,
		width: 1,
		backgroundColor: "currentColor",
		pointerEvents: "none",
		animation: "block-caret-blink 1s step-end infinite"
	}, m = l === "before" ? "before" : l === "after" ? "after" : t ? "active" : "inactive";
	return /* @__PURE__ */ f(gn, {
		element: a,
		children: /* @__PURE__ */ p("div", {
			lang: e.element.lang || n.lang,
			"data-id": a.id,
			"data-type": a.type,
			...u ? { "data-role": u } : {},
			"data-state": m,
			...c ? { "data-block-selected": "" } : {},
			className: `${a.class} ${a.type} ${s.class} relative group`,
			style: {
				position: "relative",
				...c ? { userSelect: "none" } : {}
			},
			...o,
			children: [
				/* @__PURE__ */ f(s.component, {
					element: a,
					options: e.options,
					editor: n,
					children: e.children
				}),
				a.class !== "text" && a.class !== "inline" && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-focus-ring",
					style: {
						position: "absolute",
						inset: 0,
						pointerEvents: "none"
					}
				}),
				c && /* @__PURE__ */ f("div", {
					contentEditable: !1,
					className: "tb-block-selected",
					style: {
						position: "absolute",
						inset: -2,
						pointerEvents: "none",
						outline: "2px solid Highlight",
						outlineOffset: "2px",
						borderRadius: "var(--tb-focus-ring-radius, 5px)"
					}
				}),
				l === "before" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: {
						...d,
						insetInlineEnd: "unset",
						insetInlineStart: -5
					}
				}),
				l === "after" && /* @__PURE__ */ f("div", {
					"aria-hidden": !0,
					style: d
				})
			]
		})
	});
}
//#endregion
//#region lib/components/Element/InlineElement.tsx
function En({ attributes: e, children: t, element: n, entry: r, options: i }) {
	let a = N();
	return r.asOwnElement ? null : /* @__PURE__ */ f("span", {
		className: `inline ${r.type}`,
		"data-id": n.id,
		"data-type": n.type,
		...e,
		children: /* @__PURE__ */ f(r.component, {
			element: n,
			options: i,
			editor: a,
			children: t
		})
	});
}
//#endregion
//#region lib/components/Element/UnknownElement.tsx
function Dn({ element: e, attributes: t, children: n }) {
	return /* @__PURE__ */ f(gn, { children: /* @__PURE__ */ p("div", {
		contentEditable: !1,
		className: "textbit-parent textbit-unknown",
		"data-id": e.id,
		"data-type": e.type,
		...t,
		children: [/* @__PURE__ */ p("pre", {
			style: { fontSize: "80%" },
			children: [
				" ",
				"UNKNOWN OBJECT(",
				e.type,
				")"
			]
		}), /* @__PURE__ */ f("div", {
			style: { opacity: "0.4" },
			children: n
		})]
	}) });
}
//#endregion
//#region lib/components/Element/Element.tsx
function On(e) {
	let t = N(), { element: n } = e, { components: r } = K(), i = r.get(n.type);
	if (!i) return /* @__PURE__ */ f(Dn, { ...e });
	let a = O.findPath(t, n);
	if (a.length === 1) return /* @__PURE__ */ f(Tn, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	if (i.class === "inline") return /* @__PURE__ */ f(En, {
		...e,
		entry: i.componentEntry,
		options: i.pluginOptions
	});
	let o = y.get(t, [a[0]]);
	return /* @__PURE__ */ f(Qt, {
		...e,
		entry: i.componentEntry,
		rootNode: o,
		options: i.pluginOptions
	});
}
//#endregion
//#region lib/components/Element/LeafElement.tsx
function kn(e) {
	let { leaf: t } = e, { plugins: n } = K();
	if (!t) return /* @__PURE__ */ f(d, {});
	let r = Object.keys(t).reduce((e, n) => t[n] === !0 ? [...e, n] : e, []), i = "leaf", a = {};
	for (let e of n) if (r.includes(e.name) && B.isLeafPlugin(e)) {
		let t = e.getStyle();
		typeof t == "string" ? i += t ? ` ${t}` : "" : a = {
			...a,
			...t
		};
	}
	return t.text === "" && (a.paddingLeft = "0.1px"), t.spellingError ? /* @__PURE__ */ f(Pn, {
		...e,
		className: i,
		style: a
	}) : t.placeholder ? /* @__PURE__ */ f(Nn, {
		...e,
		className: i,
		style: a
	}) : t.newline ? /* @__PURE__ */ f(An, {
		...e,
		className: i,
		style: a
	}) : t.nonBreakingSpace ? /* @__PURE__ */ f(jn, {
		...e,
		className: i,
		style: a
	}) : /* @__PURE__ */ f(Mn, {
		...e,
		className: i,
		style: a
	});
}
function An(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: `${r} tb-newline`,
		"data-newline": !0,
		...t,
		children: e.children
	});
}
function jn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: {
			...n,
			backgroundColor: "color-mix(in srgb, currentColor 24%, transparent)",
			boxShadow: "inset 0 0 0 1px color-mix(in srgb, currentColor 55%, transparent)",
			borderRadius: "2px"
		},
		className: `${r} textbit-nbsp`,
		"data-nbsp": !0,
		...t,
		children: e.children
	});
}
function Mn(e) {
	let { attributes: t, style: n, className: r } = e;
	return /* @__PURE__ */ f("span", {
		style: n,
		className: r,
		...t,
		children: e.children
	});
}
function Nn(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = l(null), [s, c] = u(void 0);
	return o(() => {
		a.current && c(a.current.offsetWidth);
	}, [t.placeholder]), /* @__PURE__ */ p("div", {
		style: {
			...r,
			width: "100%",
			position: "relative",
			minWidth: s
		},
		className: i,
		...n,
		children: [e.children, t.placeholder && /* @__PURE__ */ f(Fn, {
			ref: a,
			value: t.placeholder,
			style: r
		})]
	});
}
function Pn(e) {
	let { leaf: t, attributes: n, style: r, className: i } = e, a = t.spellingError;
	return /* @__PURE__ */ f("span", {
		style: r,
		className: i,
		"data-spelling-error": a?.id || "",
		"data-spelling-level": a?.level || void 0,
		...n,
		children: e.children
	});
}
function Fn({ value: e, style: t, ref: n }) {
	return /* @__PURE__ */ f("div", {
		ref: n,
		"data-slate-placeholder": !0,
		style: {
			...t,
			opacity: .333,
			position: "absolute",
			top: 0,
			pointerEvents: "none",
			whiteSpace: "nowrap"
		},
		contentEditable: !1,
		children: e
	});
}
//#endregion
//#region lib/hooks/useContextMenu.tsx
function In(e = !0) {
	let t = N(), n = i(W);
	return s(() => (r) => {
		let i = r.target.nodeType === Node.TEXT_NODE ? r.target.parentElement : r.target;
		if (!i) return;
		let [a, o] = ht(t, i) || [];
		if (!a || !Array.isArray(o)) return;
		let s = t.children[o[0]];
		if (!_.isElement(s)) return;
		let c = Ln(t, s, i, r), l = gt(t, r);
		l && (E.select(t, l), O.focus(t)), e && r.preventDefault(), c && n?.dispatch({
			menu: {
				position: {
					x: r.clientX,
					y: r.clientY
				},
				target: i,
				originalEvent: r,
				nodeEntry: [a, o]
			},
			spelling: c
		});
	}, [
		n,
		e,
		t
	]);
}
function Ln(e, t, n, r) {
	let i = n.closest("[data-spelling-error]")?.dataset.spellingError;
	if (!t.id || !i) return;
	let a = (e.spellingLookupTable.get(t.id)?.errors || []).find((e) => e.id === i);
	try {
		return a ? {
			...a,
			range: gt(e, r),
			apply: (t) => {
				U.replaceStringAtPosition(e, a.text, t);
			}
		} : void 0;
	} catch (e) {
		console.warn(e);
	}
}
//#endregion
//#region lib/contexts/DragStateProvider.tsx
function Rn({ children: e }) {
	let t = l(0), [n, r] = u(void 0), [i, a] = u(!1);
	return /* @__PURE__ */ f($t.Provider, {
		value: {
			dragOver: i,
			offset: n,
			setOffset: r,
			onDragEnter: () => {
				a(!0), t.current++;
			},
			onDragLeave: () => {
				setTimeout(() => {
					--t.current === 0 && a(!1);
				});
			},
			onDrop: () => {
				a(!1);
			}
		},
		children: /* @__PURE__ */ f("div", {
			style: {
				height: "100%",
				position: "relative"
			},
			children: e
		})
	});
}
//#endregion
//#region lib/contexts/PendingDropsContext.tsx
var zn = n(null);
//#endregion
//#region lib/contexts/PendingDropsProvider.tsx
function Bn({ editor: e, children: t }) {
	let n = j() ?? e, [i, s] = u(() => /* @__PURE__ */ new Map()), c = l(i);
	c.current = i;
	let d = r((e) => {
		let t = crypto.randomUUID();
		return s((n) => {
			let r = new Map(n);
			return r.set(t, {
				pathRef: e.pathRef,
				kind: e.kind
			}), r;
		}), t;
	}, []), p = r((e) => {
		s((t) => {
			let n = t.get(e);
			if (!n) return t;
			n.pathRef.unref();
			let r = new Map(t);
			return r.delete(e), r;
		});
	}, []);
	o(() => (n.pendingDrops = {
		start: d,
		end: p
	}, () => {
		delete n.pendingDrops;
	}), [
		n,
		d,
		p
	]), a(() => () => {
		for (let e of c.current.values()) e.pathRef.unref();
	}, []), a(() => {
		if (!I.isCursorEditor(n)) return;
		let e = n.awareness, t = n.sharedRoot, r = [];
		for (let [e, a] of i) {
			let i = a.pathRef.current;
			if (i) try {
				let o = h.start(n, i), s = ae(t, n, o);
				r.push({
					id: e,
					relPos: Array.from(F.encodeRelativePosition(s)),
					kind: a.kind
				});
			} catch {}
		}
		e.setLocalStateField("pendingDrops", r.length ? r : null);
	}, [n, i]), a(() => {
		if (!I.isCursorEditor(n)) return;
		let e = n.awareness;
		return () => {
			e.setLocalStateField("pendingDrops", null);
		};
	}, [n]);
	let [m, g] = u([]);
	a(() => {
		if (!I.isCursorEditor(n)) return;
		let e = n.awareness, t = e.clientID, r = /* @__PURE__ */ new Map(), i = () => {
			let n = [], i = /* @__PURE__ */ new Map(), a = e.getStates();
			for (let [e, r] of a) {
				if (e === t) continue;
				let a = r.pendingDrops;
				if (Array.isArray(a)) {
					i.set(e, JSON.stringify(a));
					for (let t of a) !t || typeof t.id != "string" || !Array.isArray(t.relPos) || n.push({
						peerId: e,
						raw: t,
						peerData: r.data
					});
				}
			}
			r.clear();
			for (let [e, t] of i) r.set(e, t);
			g(n);
		}, a = ({ added: n, updated: a, removed: o }) => {
			let s = o.some((e) => r.has(e));
			if (!s) {
				let i = e.getStates();
				for (let e of n.concat(a)) {
					if (e === t) continue;
					let n = i.get(e)?.pendingDrops;
					if ((Array.isArray(n) ? JSON.stringify(n) : "") !== (r.get(e) ?? "")) {
						s = !0;
						break;
					}
				}
			}
			s && i();
		};
		return i(), e.on("change", a), () => {
			e.off("change", a);
		};
	}, [n]);
	let _ = l(/* @__PURE__ */ new Map()), v = r((e) => {
		let t = e.join(","), n = _.current.get(t);
		return n || (n = F.decodeRelativePosition(Uint8Array.from(e)), _.current.set(t, n)), n;
	}, []), y = [];
	for (let [e, t] of i) {
		let n = t.pathRef.current;
		n && y.push({
			id: e,
			source: "own",
			path: n,
			kind: t.kind
		});
	}
	if (I.isCursorEditor(n) && m.length) {
		let e = n.sharedRoot;
		for (let { peerId: t, raw: r, peerData: i } of m) try {
			let a = v(r.relPos), o = ie(e, n, a);
			if (!o) continue;
			y.push({
				id: `${t}:${r.id}`,
				source: "peer",
				path: o.path.slice(0, 1),
				kind: r.kind,
				peerId: t,
				peerData: i
			});
		} catch {}
	}
	let b = {
		drops: y,
		start: d,
		end: p
	};
	return /* @__PURE__ */ f(zn.Provider, {
		value: b,
		children: t
	});
}
//#endregion
//#region lib/components/PresenceOverlay/RemoteCursorOverlay.tsx
function Vn({ children: e }) {
	let t = l(null), [n] = le({ containerRef: t });
	return /* @__PURE__ */ p("div", {
		style: {
			height: "100%",
			position: "relative"
		},
		className: "textbit-y-overlay",
		ref: t,
		children: [e, n.map((e) => /* @__PURE__ */ f(Hn, { ...e }, e.clientId))]
	});
}
function Hn({ data: e, selectionRects: t, caretPosition: n }) {
	if (!e) return null;
	let r = {
		position: "absolute",
		pointerEvents: "none",
		backgroundColor: e?.color || "gray",
		opacity: .5
	};
	return /* @__PURE__ */ p(d, { children: [t.map((e, t) => /* @__PURE__ */ f("div", {
		className: "textbit-y-selection",
		style: {
			...r,
			...e
		}
	}, t)), n && /* @__PURE__ */ f(Un, {
		caretPosition: n,
		data: e
	})] });
}
function Un({ caretPosition: e, data: t }) {
	let n = l(null), [r, i] = u(!0);
	a(() => {
		if (!n.current) return;
		let e = n.current.closest(".textbit-y-overlay");
		if (!e) return;
		let t = n.current.getBoundingClientRect(), r = e.getBoundingClientRect();
		i(t.top - r.top > t.height);
	}, [e]);
	let o = s(() => ({
		position: "absolute",
		...e,
		background: t?.color || "gray",
		width: "2px"
	}), [e, t?.color]), c = s(() => ({
		backgroundColor: t?.color?.trim() || "gray",
		position: "absolute",
		fontFamily: "sans-serif",
		fontSize: "80%",
		borderRadius: "2px",
		transform: r ? "translateY(-91%)" : `translateY(${e?.height || 44}px)`,
		width: "max-content",
		padding: "0px 6px 1px 6px",
		opacity: .9,
		whiteSpace: "nowrap",
		top: 0,
		borderBottomLeftRadius: 0
	}), [
		t?.color,
		r,
		e?.height
	]);
	return /* @__PURE__ */ f("div", {
		ref: n,
		style: o,
		className: "textbit-y-caret",
		children: /* @__PURE__ */ f("div", {
			style: c,
			children: t?.name || "?"
		})
	});
}
//#endregion
//#region lib/components/PresenceOverlay/PresenceOverlay.tsx
function Wn({ children: e, isCollaborative: t }) {
	let { readOnly: n } = q();
	return /* @__PURE__ */ f(d, { children: f(!t || n ? d : Vn, { children: e }) });
}
//#endregion
//#region lib/components/SelectionBoundsDetails.tsx
function Gn() {
	let e = Z(), t = l(null);
	return a(() => {
		t.current && (t.current.style.top = `${e?.y}px`, t.current.style.left = `${e?.x}px`, t.current.style.width = `${e?.width}px`, t.current.style.height = `${e?.height}px`);
	}, [e]), /* @__PURE__ */ f("div", {
		ref: t,
		style: {
			position: "absolute",
			top: 0,
			left: 0,
			outline: "1px solid rgba(191, 191, 99, 0.5",
			outlineOffset: "4px"
		},
		children: e && /* @__PURE__ */ p("div", {
			style: {
				position: "absolute",
				top: "calc(100% + 1px)",
				left: "calc(80% + 4px)",
				pointerEvents: "none",
				background: "rgb(255, 255, 255)",
				borderRadius: "2px",
				padding: "4px 6px",
				color: "rgba(225, 99, 99, 0.8)",
				fontSize: "11px",
				whiteSpace: "nowrap",
				fontFamily: "monospace",
				fontWeight: "bold",
				border: "1px solid rgba(255, 99, 99, 0.8)",
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
				gridTemplateRows: "1fr 1fr",
				gridGap: "6px 10px"
			},
			children: [
				/* @__PURE__ */ p("div", { children: ["x:", Math.round(e.x)] }),
				/* @__PURE__ */ p("div", { children: ["y:", Math.round(e.y)] }),
				/* @__PURE__ */ p("div", { children: ["w:", Math.round(e.width)] }),
				/* @__PURE__ */ p("div", { children: ["h:", Math.round(e.height)] })
			]
		})
	});
}
//#endregion
//#region lib/contexts/AdjacentBlockProvider.tsx
function Kn({ value: e, children: t }) {
	return /* @__PURE__ */ f(xn.Provider, {
		value: e,
		children: t
	});
}
//#endregion
//#region lib/contexts/BlockSelectionProvider.tsx
function qn({ value: e, children: t }) {
	return /* @__PURE__ */ f(Cn.Provider, {
		value: e,
		children: t
	});
}
//#endregion
//#region lib/utils/hasMark.ts
var Jn = (e, t) => {
	let n = U.selectedTextEntries(e);
	if (!n.length) return !1;
	for (let [e] of n) if (!w.isText(e) || !Object.keys(e).includes(t) || e[t] !== !0) return !1;
	return !0;
}, Yn = (e, t) => {
	Jn(e, t) ? h.removeMark(e, t) : h.addMark(e, t, !0);
};
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/blockUtils.ts
function Xn(e, t) {
	return t.children.findIndex((t) => !_.isElement(t) || !e.isVoid(t));
}
function Zn(e, t) {
	return t.children.reduce((t, n, r) => !_.isElement(n) || !e.isVoid(n) ? r : t, -1);
}
function Qn(e, t, n) {
	let r = e.children[n];
	if (!_.isElement(r)) return !1;
	let i = Xn(e, r);
	return i < 0 ? h.isStart(e, t, [n]) : h.isStart(e, t, [n, i]);
}
function $n(e, t, n) {
	let r = e.children[n];
	if (!_.isElement(r)) return !1;
	let i = Zn(e, r);
	return i < 0 ? h.isEnd(e, t, [n]) : h.isEnd(e, t, [n, i]);
}
function J(e, t) {
	return e.children.findIndex((e) => _.isElement(e) && e.id === t.blockId);
}
function er(e, t) {
	t < e.children.length ? E.select(e, h.start(e, [t])) : e.children.length > 0 && E.select(e, h.end(e, [e.children.length - 1]));
}
function Y(e, t, n) {
	let r = t, i = Xn(e, n);
	i >= 0 && (r = [...t, i]), E.select(e, h.start(e, r));
}
function X(e, t, n) {
	let r = t, i = Zn(e, n);
	i >= 0 && (r = [...t, i]), E.select(e, h.end(e, r));
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/arrowHandlers.ts
function tr(e, t, n, r, i, a) {
	let o = J(e, n);
	if (o === -1) {
		r(null);
		return;
	}
	let s = [o], c = e.children[o], l = _.isElement(c) && e.isVoid(c), { direction: u } = n;
	if (i && u === "before") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "after"
		}) : (Y(e, s, c), r(null));
		return;
	}
	if (i && u === "after") {
		t.preventDefault();
		let n = o + 1;
		if (n < e.children.length) {
			let t = e.children[n];
			E.select(e, h.start(e, [n])), _.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "before"
			}) : r(null);
		} else r(null);
		return;
	}
	if (a && u === "after") {
		t.preventDefault(), l ? r({
			blockId: n.blockId,
			direction: "before"
		}) : (X(e, s, c), r(null));
		return;
	}
	if (a && u === "before") {
		t.preventDefault();
		let n = o - 1;
		if (n >= 0) {
			let t = e.children[n];
			E.select(e, h.end(e, [n])), _.isElement(t) && t.class !== "text" ? r({
				blockId: t.id,
				direction: "after"
			}) : r(null);
		} else r(null);
		return;
	}
	r(null);
}
function nr(e, t, n, r) {
	let i = J(e, n);
	if (i === -1) {
		t.preventDefault();
		return;
	}
	let a = t.key === "ArrowUp", o = a ? i - 1 : i + 1;
	if (o < 0 || o >= e.children.length) {
		t.preventDefault();
		return;
	}
	let s = e.children[o];
	if (_.isElement(s) && s.class !== "text") {
		t.preventDefault(), n.direction === "after" ? X(e, [o], s) : Y(e, [o], s), r({
			blockId: s.id,
			direction: n.direction
		});
		return;
	}
	let c = e.children[i], l = _.isElement(c) && e.isVoid(c);
	if (n.direction === "after" && a || n.direction === "before" && !a || l) {
		t.preventDefault(), E.select(e, a ? h.end(e, [o]) : h.start(e, [o])), r(null);
		return;
	}
	r(null);
}
function rr(e, t, n, r, i, a, o) {
	let s = [a], c = e.children[a];
	if (r) {
		if (_.isElement(c) && c.class !== "text" && $n(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "after"
		}), !0;
		if (h.isEnd(e, o, s)) {
			let r = a + 1;
			if (r < e.children.length) {
				let i = e.children[r];
				if (_.isElement(i) && i.class !== "text") return t.preventDefault(), Y(e, [r], i), n({
					blockId: i.id,
					direction: "before"
				}), !0;
			}
		}
	}
	if (i) {
		if (_.isElement(c) && c.class !== "text" && Qn(e, o, a)) return t.preventDefault(), n({
			blockId: c.id,
			direction: "before"
		}), !0;
		if (h.isStart(e, o, s)) {
			let r = a - 1;
			if (r >= 0) {
				let i = e.children[r];
				if (_.isElement(i) && i.class !== "text") return t.preventDefault(), E.select(e, h.end(e, [r])), n({
					blockId: i.id,
					direction: "after"
				}), !0;
			}
		}
	}
	return !1;
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/nonArrowHandler.ts
function ir(e, t, n, r) {
	if (t.key === "Enter") {
		let i = J(e, n);
		if (i !== -1) {
			t.preventDefault();
			let a = n.direction === "before" ? i : i + 1, o = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return E.insertNodes(e, o, { at: [a] }), E.select(e, h.start(e, [a])), r(null), !0;
		}
	}
	let { selection: i } = e;
	if (i && C.isCollapsed(i)) {
		if (t.key === "Backspace" && n.direction === "after") {
			let i = J(e, n);
			if (i !== -1) {
				t.preventDefault(), E.removeNodes(e, { at: [i] });
				let n = i - 1;
				return n >= 0 && n < e.children.length ? E.select(e, h.end(e, [n])) : e.children.length > 0 && E.select(e, h.start(e, [0])), r(null), !0;
			}
		}
		if (t.key === "Backspace" && n.direction === "before") {
			let i = J(e, n);
			if (i !== -1) {
				let n = i - 1, a = n >= 0 ? e.children[n] : null;
				if (a && _.isElement(a)) {
					if (t.preventDefault(), a.class !== "text") {
						E.removeNodes(e, { at: [n] });
						let t = e.children[n];
						return _.isElement(t) && t.class !== "text" ? (Y(e, [n], t), r({
							blockId: t.id,
							direction: "before"
						})) : (er(e, n), r(null)), !0;
					}
					return y.string(a) === "" ? (E.removeNodes(e, { at: [n] }), er(e, n)) : (E.select(e, h.end(e, [n])), E.delete(e, {
						unit: "character",
						reverse: !0
					})), r(null), !0;
				}
			}
		}
		if (t.key === "Delete" && n.direction === "before") {
			let i = J(e, n);
			if (i !== -1) {
				if (t.preventDefault(), E.removeNodes(e, { at: [i] }), i < e.children.length) {
					let t = e.children[i];
					_.isElement(t) && t.class !== "text" ? (Y(e, [i], t), r({
						blockId: t.id,
						direction: "before"
					})) : (E.select(e, h.start(e, [i])), r(null));
				} else if (e.children.length > 0) {
					let t = e.children.length - 1, n = e.children[t];
					_.isElement(n) && n.class !== "text" ? (X(e, [t], n), r({
						blockId: n.id,
						direction: "after"
					})) : (E.select(e, h.end(e, [t])), r(null));
				} else r(null);
				return !0;
			}
		}
	}
	if ([
		"Meta",
		"Control",
		"Alt",
		"Shift",
		"CapsLock"
	].includes(t.key) || (t.metaKey || t.ctrlKey) && t.key === "v") return !0;
	if (t.key.length === 1 && !t.ctrlKey && !t.metaKey && !t.altKey) {
		let t = J(e, n);
		if (t !== -1) {
			let i = n.direction === "before" ? t : t + 1, a = {
				id: crypto.randomUUID(),
				class: "text",
				type: "core/text",
				children: [{ text: "" }]
			};
			return E.insertNodes(e, a, { at: [i] }), E.select(e, h.start(e, [i])), r(null), !0;
		}
	}
	return r(null), !1;
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/blockSelectionHandler.ts
function ar(e, t) {
	let n = Math.min(t.anchorIndex, t.focusIndex), r = Math.max(t.anchorIndex, t.focusIndex);
	E.select(e, {
		anchor: h.start(e, [n]),
		focus: h.end(e, [r])
	});
}
function or(e, t, n) {
	let r = Math.min(t.anchorIndex, t.focusIndex), i = Math.max(t.anchorIndex, t.focusIndex);
	h.withoutNormalizing(e, () => {
		for (let t = i; t >= r; t--) E.removeNodes(e, { at: [t] });
	}), n(null), r < e.children.length ? E.select(e, h.start(e, [r])) : e.children.length > 0 && E.select(e, h.end(e, [e.children.length - 1]));
}
function sr(e, t, n) {
	let r = J(e, n);
	if (r === -1) return null;
	let i = t.key === "ArrowDown" || t.key === "ArrowRight", { direction: a } = n, o;
	if (o = a === "before" && !i ? r - 1 : a === "before" && i || a === "after" && !i ? r : r + 1, o < 0 || o >= e.children.length) return null;
	let s = {
		anchorIndex: o,
		focusIndex: o
	};
	return ar(e, s), s;
}
function cr(e, t, n, r, i) {
	let a = t.key, o = a === "ArrowUp" || a === "ArrowDown" || a === "ArrowLeft" || a === "ArrowRight", s = t.metaKey || t.ctrlKey;
	if (t.shiftKey && o) {
		t.preventDefault();
		let i = a === "ArrowDown" || a === "ArrowRight", o = e.children.length - 1, s = i ? Math.min(n.focusIndex + 1, o) : Math.max(n.focusIndex - 1, 0), c = {
			...n,
			focusIndex: s
		};
		r(c), ar(e, c);
		return;
	}
	if (o && !t.shiftKey) {
		t.preventDefault();
		let o = Math.min(n.anchorIndex, n.focusIndex), s = Math.max(n.anchorIndex, n.focusIndex), c = a === "ArrowUp" || a === "ArrowLeft", l = c ? o : s, u = e.children[l];
		r(null), _.isElement(u) && u.class !== "text" ? c ? (Y(e, [l], u), i({
			blockId: u.id,
			direction: "before"
		})) : (X(e, [l], u), i({
			blockId: u.id,
			direction: "after"
		})) : c ? E.select(e, h.start(e, [l])) : E.select(e, h.end(e, [l]));
		return;
	}
	if (a === "Backspace" || a === "Delete") {
		t.preventDefault(), or(e, n, r);
		return;
	}
	if (!(s && a === "c")) {
		if (s && a === "x") {
			document.execCommand("copy"), t.preventDefault(), or(e, n, r);
			return;
		}
		s && a === "v" || t.preventDefault();
	}
}
//#endregion
//#region lib/components/TextbitEditable/handleOnKeyDown/handleOnKeyDown.ts
function lr(e, t, n, r, i, a, o) {
	if (a) {
		cr(e, n, a, o, i);
		return;
	}
	if (r && n.shiftKey && (n.key === "ArrowUp" || n.key === "ArrowDown" || n.key === "ArrowLeft" || n.key === "ArrowRight")) {
		let t = sr(e, n, r);
		t && (n.preventDefault(), i(null), o(t));
		return;
	}
	let s = n.key, c = s === "ArrowRight", l = s === "ArrowLeft";
	if (c || l) {
		let { selection: t } = e;
		if (!t || !C.isCollapsed(t)) {
			r && i(null);
			return;
		}
		let { anchor: a } = t, o = a.path[0];
		if (r) {
			tr(e, n, r, i, c, l);
			return;
		}
		if (rr(e, n, i, c, l, o, a)) return;
	} else if (s === "ArrowUp" || s === "ArrowDown") {
		if (r) {
			nr(e, n, r, i);
			return;
		}
		let { selection: t } = e;
		if (t && C.isCollapsed(t)) {
			let { anchor: r } = t, i = r.path[0], a = e.children[i];
			if (_.isElement(a) && a.class !== "text") {
				if (s === "ArrowDown" && i === e.children.length - 1 && $n(e, r, i)) {
					n.preventDefault();
					return;
				}
				if (s === "ArrowUp" && i === 0 && Qn(e, r, i)) {
					n.preventDefault();
					return;
				}
			}
		}
	} else if (r && ir(e, n, r, i)) return;
	for (let r of t) if (r.isHotkey(n)) {
		if (r.handler && !r.handler({
			editor: e,
			event: n,
			type: r.plugin.name,
			options: { ...r.plugin.options }
		})) break;
		r.plugin.class === "leaf" ? (n.preventDefault(), Yn(e, r.plugin.name)) : r.plugin.class === "text" && (n.preventDefault(), E.setNodes(e, { type: r.plugin.name }, { match: (t) => _.isElement(t) && h.isBlock(e, t) }));
		break;
	}
}
//#endregion
//#region lib/utils/trimWhitespace.ts
var ur = ({ editor: e }) => {
	let t = [];
	for (let [n, r] of h.nodes(e, {
		at: [],
		match: (e) => _.isElement(e)
	})) {
		if (r.length !== 1) continue;
		let [e, i] = y.first(n, []);
		if (w.isText(e)) {
			let n = e.text.match(/^[\t\n\r\f\v ]+/);
			if (n) {
				let e = [...r, ...i];
				t.push({
					anchor: {
						path: e,
						offset: 0
					},
					focus: {
						path: e,
						offset: n[0].length
					}
				});
			}
		}
		let [a, o] = y.last(n, []);
		if (w.isText(a)) {
			let e = a.text.match(/[\t\n\r\f\v ]+$/);
			if (e) {
				let n = [...r, ...o], i = a.text.length;
				t.push({
					anchor: {
						path: n,
						offset: i - e[0].length
					},
					focus: {
						path: n,
						offset: i
					}
				});
			}
		}
	}
	for (let n of t.reverse()) E.delete(e, { at: n });
};
//#endregion
//#region lib/utils/blockAwarePaste.ts
function dr(e, t, n, r) {
	if (!n && !r) return "unhandled";
	let i = fr(e, n, r);
	if (i === null) return "unhandled";
	let { targetIndex: a, removeRange: o } = i, s = pr(t);
	if (s && s.length > 0) {
		h.withoutNormalizing(e, () => {
			if (o) for (let t = o.hi; t >= o.lo; t--) E.removeNodes(e, { at: [t] });
			E.insertNodes(e, s, { at: [a] });
		});
		let t = [a + s.length - 1];
		try {
			E.select(e, h.end(e, t));
		} catch {}
		return "handled";
	}
	return h.withoutNormalizing(e, () => {
		if (o) for (let t = o.hi; t >= o.lo; t--) E.removeNodes(e, { at: [t] });
		let t = {
			id: crypto.randomUUID(),
			type: "core/text",
			class: "text",
			properties: {},
			children: [{ text: "" }]
		};
		E.insertNodes(e, t, {
			at: [a],
			select: !0
		});
	}), "prepared";
}
function fr(e, t, n) {
	if (n) {
		let t = Math.min(n.anchorIndex, n.focusIndex), r = Math.max(n.anchorIndex, n.focusIndex);
		return t < 0 || r >= e.children.length ? null : {
			targetIndex: t,
			removeRange: {
				lo: t,
				hi: r
			}
		};
	}
	if (t) {
		let n = e.children.findIndex((e) => _.isElement(e) && e.id === t.blockId);
		return n === -1 ? null : {
			targetIndex: t.direction === "before" ? n : n + 1,
			removeRange: null
		};
	}
	return null;
}
function pr(e) {
	if (!e.types.includes("application/x-slate-fragment")) return null;
	let t = e.getData("application/x-slate-fragment");
	if (!t) return null;
	try {
		let e = decodeURIComponent(window.atob(t)), n = JSON.parse(e);
		return Array.isArray(n) ? n : null;
	} catch {
		return null;
	}
}
//#endregion
//#region lib/components/TextbitEditable/TextbitEditable.tsx
function mr(e) {
	let t = N(), { placeholders: n, placeholder: i, readOnly: o, dir: s, collaborative: c, verbose: m } = q(), { components: g, actions: v } = K(), b = ne(), x = In(), [S, ee] = u(/* @__PURE__ */ new Map()), [w, T] = u(null), [D, k] = u(null), { onFocus: A, onBlur: j, constraints: M, autoFocus: P = !1 } = e;
	a(() => {
		t.allowEdgeWhitespace = M?.allowEdgeWhitespace !== !1;
	}, [t, M?.allowEdgeWhitespace]);
	let F = l(!0);
	a(() => (F.current = !0, () => {
		F.current = !1;
	}), []);
	let I = l(!1), L = r((e) => {
		let n = I.current;
		I.current = !1, queueMicrotask(() => {
			n || t.selection || E.select(t, P === "end" ? h.end(t, []) : h.start(t, []));
		}), A?.(e);
	}, [
		t,
		P,
		A
	]);
	a(() => {
		typeof t.onSpellcheckComplete == "function" && t.onSpellcheckComplete((e) => {
			F.current && ee(e);
		});
	}, [t]);
	let ie = r((e) => On({ ...e }), []), ae = r((e) => kn(e), []), R = re((e) => e.children.every((e) => y.string(e) === "")), oe = r((e) => Zt(t, S, e, g, n, i, R), [
		t,
		g,
		n,
		i,
		S,
		R
	]), se = r((e) => {
		if (M?.allowEdgeWhitespace !== !1) {
			j?.(e);
			return;
		}
		queueMicrotask(() => {
			ur({ editor: t });
		}), j?.(e);
	}, [
		t,
		M,
		j
	]), ce = r((e) => {
		lr(t, v, e, w, T, D, k);
	}, [
		t,
		v,
		w,
		T,
		D,
		k
	]), le = r((e) => {
		if (!w && !D) return;
		let n = e.clipboardData;
		if (!n) return;
		let r = dr(t, n, w, D);
		r !== "unhandled" && (w && T(null), D && k(null), r === "handled" && e.preventDefault());
	}, [
		t,
		w,
		D,
		T,
		k
	]), z = r((e) => {
		I.current = !0;
		let n = e.clientX, r = e.clientY;
		for (let i = 0; i < t.children.length; i++) {
			let a = t.children[i];
			if (!_.isElement(a) || a.class === "text") continue;
			let o;
			try {
				o = O.toDOMNode(t, a);
			} catch {
				continue;
			}
			let s = o.getBoundingClientRect();
			if (r < s.top || r > s.bottom || n >= s.left && n <= s.right) continue;
			e.preventDefault(), O.focus(t);
			let c = n < (s.left + s.right) / 2 ? "before" : "after";
			c === "before" ? E.select(t, h.start(t, [i])) : E.select(t, h.end(t, [i])), T({
				blockId: a.id,
				direction: c
			}), D && k(null);
			return;
		}
		if (w && T(null), D && k(null), navigator.userAgent.includes("Gecko/") && !b) {
			let n = O.findEventRange(t, e);
			C.isRange(n) && E.select(t, n);
		}
	}, [
		t,
		b,
		w,
		T,
		D,
		k
	]);
	return /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f(qn, {
		value: D,
		children: /* @__PURE__ */ f(Kn, {
			value: w,
			children: /* @__PURE__ */ f(Rn, { children: /* @__PURE__ */ f(Wn, {
				isCollaborative: c,
				children: /* @__PURE__ */ p(Bn, {
					editor: t,
					children: [/* @__PURE__ */ f(te, {
						autoFocus: !!P,
						"data-state": b ? "focused" : "",
						readOnly: o,
						renderElement: ie,
						renderLeaf: ae,
						onFocus: L,
						onBlur: se,
						onKeyDown: ce,
						onPaste: le,
						decorate: oe,
						className: e.className,
						style: w || D ? {
							...e.style,
							caretColor: "transparent"
						} : e.style,
						spellCheck: !1,
						dir: s,
						onContextMenu: x,
						onMouseDown: z,
						"aria-label": e["aria-label"]
					}), e.children]
				})
			}) })
		})
	}), m && /* @__PURE__ */ f(Gn, {})] });
}
//#endregion
//#region lib/components/GutterProvider/Content.tsx
function hr({ children: e, style: t, className: n }) {
	return /* @__PURE__ */ f("div", {
		style: t,
		className: n,
		children: e
	});
}
//#endregion
//#region lib/components/GutterProvider/index.tsx
var gr = {
	Provider: Kt,
	Content: hr
};
//#endregion
//#region lib/components/DropMarker.tsx
function _r({ className: e, style: t = {} }) {
	let n = l(null), { offset: r, dragOver: a } = i($t), [s, c] = u(null);
	o(() => {
		if (!n.current || !a) return;
		let e = n.current.parentElement;
		if (!e) return;
		let t = vr(e);
		t && c(t.getBoundingClientRect());
	}, [a, r]);
	let d = {
		height: "3px",
		backgroundColor: "rgb(191, 191, 191)",
		borderRadius: "2px"
	}, p = { display: "none" };
	if (a && r && s) {
		let { bbox: e, position: t } = r;
		if (!e) return null;
		let n = e.left - s.left, i = e.top - s.top;
		p.display = "block", p.left = n, p.width = e.width, t?.[1] ? (p.top = i, p.height = e.height + 2, p.backgroundColor = "rgba(191, 191, 191, 0.4)", p.borderRadius = "4px") : p.top = t?.[0] === "above" ? i - 2 : i + e.height - 2;
	}
	let m = a ? r?.position?.[1] ? "around" : "between" : "none";
	return /* @__PURE__ */ f("div", {
		ref: n,
		className: e,
		"data-dragover": m,
		style: {
			pointerEvents: "none",
			position: "absolute",
			margin: 0,
			userSelect: "none",
			...d,
			...p,
			...t
		}
	});
}
function vr(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
//#endregion
//#region lib/hooks/usePendingDrops.tsx
function yr() {
	return i(zn)?.drops ?? [];
}
//#endregion
//#region lib/components/UploadMarker.tsx
var br = 60;
function xr({ className: e, style: t, height: n = br, children: r }) {
	let i = N(), s = yr(), c = l(null), [d, m] = u(null);
	o(() => {
		if (s.length === 0) return;
		let e = [];
		for (let t of s) {
			let r = Er(i, t.path);
			if (!r) continue;
			let a = r.style.marginTop;
			r.style.marginTop = `${n}px`, e.push(() => {
				r.style.marginTop = a;
			});
		}
		return () => {
			for (let t of e) t();
		};
	}, [
		s,
		i,
		n
	]), o(() => {
		if (!c.current) return;
		let e = c.current.parentElement;
		if (!e) return;
		let t = Tr(e);
		if (!t) return;
		let n = () => m(t.getBoundingClientRect());
		if (n(), s.length === 0) return;
		let r = new ResizeObserver(n);
		r.observe(t);
		let a = Array.from(e.children).find((e) => e.getAttribute("role") === "textbox");
		a && r.observe(a);
		for (let e of s) {
			let t = Er(i, e.path);
			t && r.observe(t);
		}
		return window.addEventListener("scroll", n, {
			passive: !0,
			capture: !0
		}), window.addEventListener("resize", n, { passive: !0 }), () => {
			r.disconnect(), window.removeEventListener("scroll", n, { capture: !0 }), window.removeEventListener("resize", n);
		};
	}, [s, i]);
	let h = s.filter((e) => e.source === "own").length, [g, _] = u("");
	return a(() => {
		if (h === 0) {
			_("");
			return;
		}
		_(h === 1 ? "Upload in progress" : `${h} uploads in progress`);
	}, [h]), s.length === 0 || !d ? /* @__PURE__ */ f("div", {
		ref: c,
		style: { display: "none" },
		children: /* @__PURE__ */ f(Sr, { text: g })
	}) : /* @__PURE__ */ p("div", {
		ref: c,
		style: { display: "contents" },
		children: [/* @__PURE__ */ f(Sr, { text: g }), s.map((a) => {
			let o = Dr(i, a.path);
			if (!o) return null;
			let s = {
				position: "absolute",
				left: o.left - d.left,
				top: o.top - d.top - n,
				width: o.width,
				height: n,
				pointerEvents: "none",
				userSelect: "none"
			};
			return /* @__PURE__ */ f("div", {
				className: e,
				"data-source": a.source,
				"data-kind": a.kind ?? "",
				style: {
					...wr,
					...s,
					...t
				},
				children: r ? r(a) : null
			}, a.id);
		})]
	});
}
function Sr({ text: e }) {
	return /* @__PURE__ */ f("div", {
		role: "status",
		"aria-live": "polite",
		"aria-atomic": "true",
		style: Cr,
		children: e
	});
}
var Cr = {
	position: "absolute",
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0, 0, 0, 0)",
	whiteSpace: "nowrap",
	border: 0
}, wr = {
	background: "rgba(191, 191, 191, 0.25)",
	border: "1px dashed rgba(128, 128, 128, 0.6)",
	borderRadius: 2
};
function Tr(e) {
	let t = e;
	for (; t;) {
		if (getComputedStyle(t).position !== "static") return t;
		t = t.parentElement;
	}
	return null;
}
function Er(e, t) {
	try {
		let [n] = e.node(t);
		return O.toDOMNode(e, n);
	} catch {
		return null;
	}
}
function Dr(e, t) {
	let n = Er(e, t);
	return n ? n.getBoundingClientRect() : null;
}
//#endregion
//#region lib/hooks/useSelectionBounds.tsx
var Z = () => {
	let e = i(Fe);
	if (!e) throw Error("useTextbitSelectionBoundsState must be used within a TextbitSelectionBoundsProvider");
	let [t, n] = u(e.boundsRef.current);
	return a(() => e.subscribe(n), [e]), t;
};
//#endregion
//#region lib/components/ContextTools/Menu.tsx
function Or({ children: e, className: t }) {
	return z(/* @__PURE__ */ f(kr, {
		className: t,
		children: e
	}), document.body);
}
function kr({ children: e, className: t }) {
	let n = N(), o = Z(), s = ne(), c = wn(), u = l(null), d = i(W)?.menu != null, p = r((e) => {
		let t = u.current;
		t && (t.style.opacity = e ? "1" : "0", t.style.pointerEvents = e ? "auto" : "none");
	}, []);
	a(() => {
		if (!s) return;
		let e = !1;
		o?.isCollapsed ? n.selection && (e = !!h.nodes(n, {
			at: n.selection,
			match: (e) => H.isElement(e) && e.class === "inline"
		}).next().value) : e = !0, p(!!(e && !d && !c));
	}, [
		n,
		o,
		s,
		p,
		d,
		c
	]);
	let m = r((e) => {
		if (!s) return;
		let t = u.current;
		if (!t || !e || e.left <= 0 || e.top <= 0) return;
		let n = t.getBoundingClientRect(), r = e.left + e.width / 2 - n.width / 2, i = e.top - n.height - 8, a = window.innerWidth - n.width - 8;
		r = Math.max(8, Math.min(r, a)), i < 8 && (i = e.top + e.height + 8);
		let o = window.innerHeight - n.height - 8;
		i > o && (i = e.top - n.height - 8, i = Math.min(i, o)), t.style.transform = `translate(${r}px, ${i}px)`;
	}, [s]);
	return a(() => {
		o ? requestAnimationFrame(() => m(o)) : p(!1);
	}, [
		m,
		o,
		p
	]), a(() => {
		let e = u.current;
		if (!e) return;
		let t = new ResizeObserver(() => {
			o && requestAnimationFrame(() => m(o));
		});
		return t.observe(e), () => {
			t.disconnect();
		};
	}, [m, o]), /* @__PURE__ */ f("div", {
		ref: u,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			opacity: 0,
			pointerEvents: "none",
			willChange: "transform",
			zIndex: 9701
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContextTools/Group.tsx
function Ar({ children: n, className: i }) {
	let a = N(), o = M(), s = h.nodes(a, { mode: "lowest" }).next().value || void 0, c = r((n) => !s || !o ? n : t.toArray(n).filter((t) => C.isCollapsed(o) ? e.isValidElement(t) ? t.props?.action?.plugin?.class === "inline" : !1 : !0), [s, o])(n), l = t.count(c) > 0;
	return /* @__PURE__ */ f(d, { children: l ? /* @__PURE__ */ f("div", {
		className: i || "",
		children: n
	}) : /* @__PURE__ */ f(d, {}) });
}
//#endregion
//#region lib/components/ContextTools/Item.tsx
function jr({ action: e, className: n, children: r }) {
	let i = N(), a = M(), o = Jn(i, e.plugin.name), s = h.nodes(i, { mode: "lowest" }).next().value || void 0, c = Array.from(h.nodes(i, {
		match: (t) => H.isElement(t) && t.class === "inline" && t.type === e.plugin.name,
		at: a ?? void 0
	})), l = Array.isArray(e.tool) ? e.tool.length === 2 && c.length === 1 ? e.tool[1] : e.tool[0] : e.tool;
	if (l) {
		if (c.length === 1) {
			let e = c[0];
			return /* @__PURE__ */ p("div", {
				"data-state": "active",
				children: [t.count(r) ? /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e,
					children: r
				}) : /* @__PURE__ */ f(l, {
					editor: i,
					active: o,
					entry: e
				}), /* @__PURE__ */ f("em", { className: "active" })]
			});
		}
		return /* @__PURE__ */ f("div", {
			"data-state": o ? "active" : "inactive",
			className: n || "",
			onMouseDown: (t) => {
				c.length > 1 || (e.handler({
					editor: i,
					event: t,
					type: e.plugin.name,
					options: { ...e.plugin.options }
				}) && Yn(i, e.plugin.name), t.defaultPrevented || t.preventDefault());
			},
			children: /* @__PURE__ */ f(l, {
				editor: i,
				active: o,
				entry: s,
				children: r
			})
		});
	}
}
//#endregion
//#region lib/components/ContextTools/index.tsx
var Mr = {
	Menu: Or,
	Group: Ar,
	Item: jr
}, Nr = n([!1, () => {}]);
//#endregion
//#region lib/components/ContentTools/Menu.tsx
function Pr({ children: e, className: t, style: n = {} }) {
	let [r, i] = u(!1), s = l(null), c = Z(), d = ne(), { readOnly: p } = q();
	return o(() => {
		let e = s.current;
		if (!e || !c || p || !d) return;
		let t = e.offsetParent;
		if (!t) return;
		let n = t.getBoundingClientRect(), r = (c.box?.top ?? c.top) - n.top;
		e.style.top = `${r}px`;
	}, [
		c,
		p,
		d
	]), a(() => {
		i((e) => d ? e : !1);
	}, [d]), p || !d || !c ? null : /* @__PURE__ */ f(Nr.Provider, {
		value: [r, i],
		children: /* @__PURE__ */ f("div", {
			ref: s,
			className: t,
			"data-state": r ? "open" : "closed",
			style: {
				position: "absolute",
				top: 0,
				zIndex: 9909,
				...n
			},
			children: e
		})
	});
}
//#endregion
//#region lib/hooks/useClickGlobal.tsx
function Fr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("mousedown", e), document.addEventListener("touchstart", e), () => {
			document.removeEventListener("mousedown", e), document.removeEventListener("touchstart", e);
		};
	}, []), t;
}
//#endregion
//#region lib/components/ContentTools/Trigger.tsx
function Ir({ children: e, className: t }) {
	let [n, r] = i(Nr), { triggerRef: o, updateTriggerRef: s } = i(Gt), c = Fr(() => {
		r(!1);
	});
	return a(() => {
		o && c.current && s(c.current);
	}, [
		o,
		s,
		c
	]), /* @__PURE__ */ f("a", {
		ref: c,
		className: t,
		onMouseDown: (e) => {
			e.preventDefault(), r(!n);
		},
		children: e
	});
}
//#endregion
//#region lib/hooks/useKeydownGlobal.tsx
function Lr(e) {
	let t = l(null), n = l(e);
	return o(() => {
		n.current = e;
	}), a(() => {
		let e = (e) => {
			(t?.current)?.contains(e.target) || n.current(e);
		};
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 });
		};
	}, []), t;
}
//#endregion
//#region lib/components/ContentTools/Content.tsx
function Rr({ children: e, className: t }) {
	let [n, r] = i(Nr), a = Lr((e) => {
		n && (e.key === "Escape" || e.key === "Tab") && (e.preventDefault(), r(!1));
	});
	return /* @__PURE__ */ f("div", {
		ref: a,
		children: n && /* @__PURE__ */ f(zr, {
			className: t,
			children: e
		})
	});
}
function zr({ children: e, className: t }) {
	let { triggerRef: n } = i(Gt), r = l(null);
	return o(() => {
		let e = r.current, t = n?.current;
		if (!t || !e) return;
		let i = t.getBoundingClientRect(), a = e.getBoundingClientRect(), o = i.right + 8, s = i.top, c = window.innerWidth - a.width - 8;
		o = Math.min(o, c), s + a.height > window.innerHeight - 8 && (s = Math.max(8, window.innerHeight - a.height - 8)), e.style.transform = `translate(${o}px, ${s}px)`;
	}, [n]), /* @__PURE__ */ f("div", {
		ref: r,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			willChange: "transform"
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContentTools/Group.tsx
function Br({ children: e, className: n }) {
	let r = t.count(e) > 0;
	return /* @__PURE__ */ f(d, { children: r ? /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) : /* @__PURE__ */ f(d, {}) });
}
//#endregion
//#region lib/components/ContentTools/ItemContext.tsx
var Q = n({ isActive: !1 });
//#endregion
//#region lib/components/ContentTools/Item.tsx
function Vr({ children: e, className: t, action: n }) {
	let { plugins: r, actions: i } = K(), a = N(), o = M(), s = i.find((e) => e.name === n);
	if (!s) return /* @__PURE__ */ f(d, {});
	let [c, , l] = Hr(a, o, s) || [
		!1,
		!1,
		!1
	];
	return c ? /* @__PURE__ */ f(Q.Provider, {
		value: {
			isActive: !!l,
			action: s
		},
		children: /* @__PURE__ */ f("a", {
			className: t,
			"data-state": l ? "active" : "inactive",
			onMouseDown: (e) => {
				e.preventDefault(), s.handler({
					editor: a,
					type: s.plugin.name,
					options: s.plugin.options,
					api: { consumeFileInputChangeEvent: (e, t) => {
						en(e, r, t);
					} }
				});
			},
			children: e
		})
	}) : /* @__PURE__ */ f(d, {});
}
function Hr(e, t, n) {
	if (!t) return [
		!1,
		!1,
		!1
	];
	let r = Array.from(h.nodes(e, {
		at: h.unhangRange(e, t),
		match: (e) => !h.isEditor(e) && _.isElement(e)
	}));
	if (!r.length || !n?.visibility) return [
		!1,
		!1,
		!1
	];
	let i = r[0][0], a = r[r.length - 1][0];
	if (!H.isElement(i)) return [
		!1,
		!1,
		!1
	];
	let o = H.isElement(a) ? a : void 0;
	return n?.visibility(i, o) || [[
		!1,
		!1,
		!1
	]];
}
//#endregion
//#region lib/components/ContentTools/Icon.tsx
function Ur({ children: e, className: n }) {
	let r = N(), { isActive: a, action: o } = i(Q), s = Array.isArray(o?.tool) ? o.tool[0] || null : o?.tool || null;
	return s && !t.count(e) ? /* @__PURE__ */ p("div", {
		className: n,
		children: [a && "✓", !a && s && /* @__PURE__ */ f(s, { editor: r })]
	}) : /* @__PURE__ */ f("div", {
		className: n,
		children: e
	});
}
//#endregion
//#region lib/utils/modifier.ts
function Wr() {
	if (typeof navigator > "u") return !1;
	let e = navigator, t = e.userAgentData?.platform || e.platform || e.userAgent || "";
	return /\bmac/i.test(t);
}
var Gr = Wr(), Kr = {
	up: "↑",
	down: "↓",
	right: "→",
	left: "←"
}, qr = {
	mod: "⌘",
	shift: "⇧",
	ctrl: "⌃",
	control: "⌃",
	alt: "⌥",
	opt: "⌥",
	option: "⌥"
}, Jr = {
	mod: "Ctrl",
	ctrl: "Ctrl",
	control: "Ctrl",
	shift: "Shift",
	alt: "Alt",
	opt: "Alt",
	option: "Alt"
};
function Yr(e, t = Gr) {
	return e ? e.split("+").map((e) => Xr(e, t)).filter(Boolean).join(t ? "" : "+") : "";
}
function Xr(e, t) {
	let n = e.toLowerCase();
	return ((t ? qr : Jr)[n] ?? Kr[n]) || (e.length === 1 ? e.toUpperCase() : e);
}
//#endregion
//#region lib/components/ContentTools/Hotkey.tsx
function Zr({ className: e, children: n }) {
	let { action: r } = i(Q);
	return /* @__PURE__ */ f("div", {
		className: e,
		children: t.count(n) ? n : Yr(r?.hotkey || "")
	});
}
//#endregion
//#region lib/components/ContentTools/Label.tsx
function Qr({ children: e, className: n }) {
	let { action: r } = i(Q);
	return /* @__PURE__ */ f("div", {
		className: n,
		children: t.count(e) ? e : r?.title || ""
	});
}
//#endregion
//#region lib/components/ContentTools/index.tsx
var $ = {
	Menu: Pr,
	Trigger: Ir,
	Content: Rr,
	Group: Br,
	Item: Vr,
	Icon: Ur,
	Hotkey: Zr,
	Label: Qr
};
//#endregion
//#region lib/components/ContextMenu/useContextMenuHints.tsx
function $r() {
	let e = i(W);
	if (e === void 0) throw Error("useContextMenu must be used within a ContextMenuContextProvider");
	return {
		menu: e.menu,
		spelling: e.spelling
	};
}
//#endregion
//#region lib/components/ContextMenu/Menu.tsx
function ei({ children: e, className: t }) {
	return z(/* @__PURE__ */ f(ti, {
		className: t,
		children: e
	}), document.body);
}
function ti({ children: e, className: t }) {
	let { readOnly: n } = q(), o = i(W), s = l(null), { menu: c } = $r(), u = r(() => {
		let e = s.current;
		if (!e || !c?.position) return;
		let t = e.getBoundingClientRect(), { x: n, y: r } = c.position, i = n, a = r + 8, o = window.innerWidth - t.width - 8;
		i = Math.max(8, Math.min(i, o)), a + t.height > window.innerHeight - 8 && (a = r - t.height - 8), e.style.transform = `translate(${i}px, ${a}px)`;
	}, [c?.position]);
	return a(() => {
		if (!c?.position || n) return;
		let e = (e) => {
			s.current?.contains(e.target) || o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		};
		return window.addEventListener("pointerdown", e, { capture: !0 }), window.addEventListener("keydown", e, { capture: !0 }), () => {
			window.removeEventListener("pointerdown", e, { capture: !0 }), window.removeEventListener("keydown", e, { capture: !0 });
		};
	}, [
		n,
		c?.position,
		o
	]), a(() => {
		!n && c?.position && requestAnimationFrame(u);
	}, [
		n,
		c?.position,
		u
	]), !c?.position || n ? null : /* @__PURE__ */ f("div", {
		ref: s,
		className: t,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			willChange: "transform",
			pointerEvents: "auto",
			zIndex: 9702
		},
		children: e
	});
}
//#endregion
//#region lib/components/ContextMenu/Group.tsx
function ni({ children: e, className: n }) {
	return /* @__PURE__ */ f(d, { children: t.count(e) > 0 && /* @__PURE__ */ f("div", {
		className: n,
		children: e
	}) });
}
//#endregion
//#region lib/components/ContextMenu/Item.tsx
function ri({ children: e, className: n, func: r = void 0 }) {
	let a = N(), o = i(W);
	return t.count(e) ? /* @__PURE__ */ f("a", {
		className: n,
		onMouseDown: (e) => {
			e.preventDefault(), r && r(a), o?.dispatch({
				menu: void 0,
				spelling: void 0
			});
		},
		children: e
	}) : /* @__PURE__ */ f(d, {});
}
//#endregion
//#region lib/components/ContextMenu/index.tsx
var ii = {
	Root: ei,
	Group: ni,
	Item: ri
};
//#endregion
//#region lib/hooks/useAction.tsx
function ai(e, t) {
	let n = N(), { actions: r } = K(), i = `${e}/${t}`, a = r.find((e) => e.name === i);
	if (a) return (t) => {
		a.handler({
			editor: n,
			type: e,
			options: a.plugin.options,
			args: t
		});
	};
}
//#endregion
//#region lib/hooks/useEditor.tsx
function oi() {
	return N();
}
//#endregion
//#region lib/hooks/useSelectionStats.tsx
var si = {
	words: 0,
	characters: 0,
	charactersNoSpaces: 0
}, ci = () => re((e) => {
	let { selection: t } = e;
	if (!t || C.isCollapsed(t)) return si;
	let [n, r] = C.edges(t), i = 0, a = 0, o = 0;
	for (let [s, c] of h.nodes(e, {
		at: t,
		match: w.isText,
		voids: !0
	})) {
		let e = s.text;
		b.equals(c, r.path) && (e = e.slice(0, r.offset)), b.equals(c, n.path) && (e = e.slice(n.offset)), a += e.length, o += (e.match(/\S/gu) || []).length, i += (e.match(/\p{L}+/gu) || []).length;
	}
	return {
		words: i,
		characters: a,
		charactersNoSpaces: o
	};
}, li);
function li(e, t) {
	return e !== null && e.words === t.words && e.characters === t.characters && e.charactersNoSpaces === t.charactersNoSpaces;
}
//#endregion
//#region lib/main.ts
var ui = {
	Root: qt,
	Editable: mr,
	Gutter: gr.Content,
	DropMarker: _r,
	UploadMarker: xr,
	Plugins: Ae,
	ContextMenu: ii
}, di = {
	Root: $.Menu,
	Trigger: $.Trigger,
	Content: $.Content,
	Group: $.Group,
	Item: $.Item,
	Icon: $.Icon,
	Label: $.Label,
	Hotkey: $.Hotkey
}, fi = {
	Root: Mr.Menu,
	Group: Mr.Group,
	Item: Mr.Item
}, pi = gr.Content;
//#endregion
export { ii as ContextMenu, _r as DropMarker, mr as Editable, m as Editor, g as Element, pi as Gutter, di as Menu, v as Node, zn as PendingDropsContext, Ae as Plugins, S as Range, qt as Root, ee as Text, ui as Textbit, U as TextbitEditor, H as TextbitElement, B as TextbitPlugin, fi as Toolbar, T as Transforms, xr as UploadMarker, Le as calculateStats, tn as consumeFileDropEvent, en as consumeFileInputChangeEvent, Wr as isMac, ai as useAction, wn as useBlockSelection, $r as useContextMenuHints, oi as useEditor, yr as usePendingDrops, K as usePluginRegistry, Z as useSelectionBounds, ci as useSelectionStats, q as useTextbit };
